// THIS FILE IS AUTO-GENERATED. DO NOT EDIT MANUALLY.

import React from 'react';


// IMAGE IMPORTS 
import aashay_inamdar from "../diaries-info/TyDiaries_2025/aashay_inamdar.png"
import mansi_kumar from "../diaries-info/TyDiaries_2025/mansi_kumar.png"
import shraddha_darade from "../diaries-info/TyDiaries_2025/shraddha_darade.png"
import atharva_satav from "../diaries-info/TyDiaries_2024/Atharva_Satav.jpg"
import yash_suryawanshi from "../diaries-info/TyDiaries_2023/yash_suryawanshi.jpg";
import gayatri_potbhare_2027 from "../diaries-info/TyDiaries_Batch_27/gayatri_potbhare.png";
import yash_g from "../diaries-info/yash_gangwar.jpg";
import kartik_mandhan from "../diaries-info/TyDiaries_2022/kartik_mandhan.jpg";
import sahil_tejwani_2027 from "../diaries-info/TyDiaries_Batch_27/sahil_tejwani.png";
import anjali_phule_2027 from "../diaries-info/TyDiaries_Batch_27/anjali_phule.png";
import advait_karmalkar from "../diaries-info/TyDiaries_2023/advait_karmalkar.jpg";
import prajakta_ghatage from "../diaries-info/TyDiaries_2022/prajakta_ghatage.jpeg";
import shantanu_benake_2027 from "../diaries-info/TyDiaries_Batch_27/shantanu_benake.png";
import tanishq_borkar_2027 from "../diaries-info/TyDiaries_Batch_27/tanishq_borkar.png";
import harshmohan_kulkarni from "../diaries-info/TyDiaries_2023/harshmohan_kulkarni.jpeg";
import harshal from "../diaries-info/harshal_patil.jpg";
import shirshak_tiple from "../diaries-info/TyDiaries_2024/Shirshak_Tiple.jpg"
import manas from "../diaries-info/manas_nighrunkar.jpg";
import sandesh_sahane from "../diaries-info/TyDiaries_2024/Sandesh_Sahane.jpg"
import aditya_naik from "../diaries-info/TyDiaries_2023/Aditya Naik.jpg";
import naishadh from "../diaries-info/naishadh_vora.jpg";
import shreya_vaidya from "../diaries-info/TyDiaries_2022/shreya_vaidya.jpg";
import nidhi_patel from "../diaries-info/TyDiaries_2023/nidhi_patel.jpg";
import akshita_dhoot from "../diaries-info/TyDiaries_2025/akshita_dhoot.png"
import siddhi_shinde from "../diaries-info/TyDiaries_2023/Siddhi Shinde.jpg";
import soumya_pachpor_2027 from "../diaries-info/TyDiaries_Batch_27/soumya_pachpor.png";
import nikhil_kokale from "../diaries-info/TyDiaries_2024/Nikhil_Kokale.jpg"
import atharva_sardesai from "../diaries-info/TyDiaries_2025/atharva_sardesai.png"
import disha_kadam_2027 from "../diaries-info/TyDiaries_Batch_27/disha_kadam.png";
import simran from "../diaries-info/simran_kucheria.jpeg";
import ishita_gaikwad from "../diaries-info/TyDiaries_2025/ishita_gaikwad.png"
import mehmood_deshmukh_2027 from "../diaries-info/TyDiaries_Batch_27/mehmood_deshmukh.png";
import soham_laghate from "../diaries-info/TyDiaries_2025/soham_laghate.png"
import preet_trivedi from "../diaries-info/TyDiaries_2024/Preet_Trivedi.jpg"
import ayush_ambhorkar from "../diaries-info/TyDiaries_2024/Ayush_Ambhorkar.jpg"
import krushna_bankar_2027 from "../diaries-info/TyDiaries_Batch_27/krushna_bankar.png";
import aryan_mehta_2027 from "../diaries-info/TyDiaries_Batch_27/aryan_mehta.png";
import soham_kumthekar from "../diaries-info/TyDiaries_2024/Soham_Kumthekar.jpg"
import vedanshi_shah from "../diaries-info/TyDiaries_2023/Vedanshi Shah.jpg";
import chinmay from "../diaries-info/chinmay_dixit.jpg";
import aman_patil from "../diaries-info/TyDiaries_2022/aman_patil.jpg";
import chitra_sangle from "../diaries-info/TyDiaries_2023/Chitra Sangle.jpg";
import falguni from "../diaries-info/falguni_patil.jpg";
import omkar from "../diaries-info/omkar_thorat.jpg";
import arnav_gavde from "../diaries-info/TyDiaries_2025/arnav_gavde.png"
import harsh_marke from "../diaries-info/TyDiaries_2024/Harsh_Marke.jpg"
import shreya from "../diaries-info/shreya_singhal.jpg";
import siddhi_landage_2027 from "../diaries-info/TyDiaries_Batch_27/siddhi_landage.png";
import arjun_deodhar from "../diaries-info/TyDiaries_2025/arjun_deodhar.png"
import kaustubh_virkar from "../diaries-info/TyDiaries_2024/Kaustubh_Virkar.jpg"
import soumitra from "../diaries-info/soumitra_tonapi.jpeg";
import nishant_agte_2027 from "../diaries-info/TyDiaries_Batch_27/nishant_agte.png";
import sanmeet from "../diaries-info/TyDiaries_2022/sanmeet.jpg";
import rhugaved from "../diaries-info/rhugaved_narmade.jpeg";
import gaurish_dodke from "../diaries-info/TyDiaries_2024/Gaurish_Dodke.jpg"
import jayesh from "../diaries-info/TyDiaries_2022/jayesh.jpg";
import vaishnavi_mulik from "../diaries-info/TyDiaries_2024/Vaishnavi_Mulik.jpg"
import darshan_shah from "../diaries-info/TyDiaries_2022/darshan_shah.jpg";
import akansha_patil_2027 from "../diaries-info/TyDiaries_Batch_27/akansha_patil.png";
import sanchit_rajmane from "../diaries-info/TyDiaries_2024/Sanchit_Rajmane.jpg"
import aniket_ware_2027 from "../diaries-info/TyDiaries_Batch_27/aniket_ware.png";
import dhruv_sadhale from "../diaries-info/TyDiaries_2025/dhruv_sadhale.png"
import aditya_deshmukh from "../diaries-info/TyDiaries_2025/aditya_deshmukh.png"
import anuksha_koul from "../diaries-info/TyDiaries_2024/Anuksha_Koul.jpg"
import riya_kulkarni_2027 from "../diaries-info/TyDiaries_Batch_27/riya_kulkarni.png";
import bhagyashree_lomesh_patil from "../diaries-info/TyDiaries_2024/Bhagyashree_Patil.jpg"
import neha_pawar from "../diaries-info/TyDiaries_2023/neha_pawar.png";
import shreyas_katkar from "../diaries-info/TyDiaries_2025/shreyas_katkar.png"
import deepika from "../diaries-info/deepika_goyal.jpeg";
import harsh_pande from "../diaries-info/TyDiaries_2023/Harsh Pande.jpg";
import chetas from "../diaries-info/chetas_borse.jpg";
import mruganksha_kudake_2027 from "../diaries-info/TyDiaries_Batch_27/mruganksha_kudake.png";
import yash_shah_2027 from "../diaries-info/TyDiaries_Batch_27/yash_shah.png";
import sameer_kavthekar from "../diaries-info/TyDiaries_2022/sameer_kavthekar.jpg";
import avishkar_andhale from "../diaries-info/TyDiaries_2022/avishkar_andhale.jpg";
import soham_dombale from "../diaries-info/TyDiaries_2024/Soham_Dombale.jpg"
import arya_kulkarni_2027 from "../diaries-info/TyDiaries_Batch_27/arya_kulkarni.png";
import sneha_venk from "../diaries-info/TyDiaries_2023/sneha_venk.png";
import himanshu_kamdi from "../diaries-info/TyDiaries_2024/Himanshu_Kamdi.jpg"
import apurva_deshpande from "../diaries-info/TyDiaries_2022/apurva_deshpande.png";
import vasu from "../diaries-info/vasu_sharma.jpeg";
import rohit_shidid from "../diaries-info/TyDiaries_2023/rohit_shidid.jpeg";
import kaustubh_kharat from "../diaries-info/TyDiaries_2025/kaustubh_kharat.png"
import christy_biju from "../diaries-info/TyDiaries_2023/christy_biju.png";
import omkar_nagwekar from "../diaries-info/TyDiaries_2024/Omkar_Nagwekar.jpg"
import deep_oak from "../diaries-info/TyDiaries_2025/deep_oak.png"
import arnav_prasad from "../diaries-info/TyDiaries_2025/arnav_prasad.png"
import suswan_joglekar_2027 from "../diaries-info/TyDiaries_Batch_27/suswan_joglekar.png";
import harish from "../diaries-info/TyDiaries_2022/harish_choudhary.jpg";
import bhargav_gejji from "../diaries-info/TyDiaries_2025/bhargav_gejji.jpg"
import parth_yewale from "../diaries-info/TyDiaries_2024/Parth_Yewale.jpg"
import atharva_mutsaddi from "../diaries-info/TyDiaries_2024/Atharva_Mutsaddi.jpg"
import simran_veer from "../diaries-info/TyDiaries_2024/Simran_Veer.jpg"
import sharvari_phand from "../diaries-info/TyDiaries_2024/Sharvari_Phand.jpg"
import hardik_mutha_2027 from "../diaries-info/TyDiaries_Batch_27/hardik_mutha.png";
import aditya_choudhary from "../diaries-info/TyDiaries_2024/Aditya_Choudhary.jpg"
import shloka_shinde_2027 from "../diaries-info/TyDiaries_Batch_27/shloka_shinde.png";
import arya_kulkarnia8_2027 from "../diaries-info/TyDiaries_Batch_27/arya_kulkarnia8.png";
import parth_mane from "../diaries-info/TyDiaries_2024/Parth_Mane.jpg"
import minautee_dighe_2027 from "../diaries-info/TyDiaries_Batch_27/minautee_dighe.png";
import vaishnavi_shambharkar_2027 from "../diaries-info/TyDiaries_Batch_27/vaishnavi_shambharkar.png";
import kunal_chaudhari from "../diaries-info/TyDiaries_2022/kunal_chaudhari.png";
import noopur_karkare_2027 from "../diaries-info/TyDiaries_Batch_27/noopur_karkare.png";
import shubham_gupta from "../diaries-info/TyDiaries_2024/Shubham_Gupta.jpg"
import riddhi from "../diaries-info/TyDiaries_2022/riddhi_tharewal.jpg";
import yash_pardeshi from "../diaries-info/TyDiaries_2025/yash_pardeshi.png"
import rutuja_dautpure from "../diaries-info/TyDiaries_2025/rutuja_dautpure.png"
import ninad_barve from "../diaries-info/TyDiaries_2023/Ninad Barve.jpg";
import arya_wankhede from "../diaries-info/TyDiaries_2025/arya_wankhede.png"
import riti_panganti from "../diaries-info/TyDiaries_2025/riti.png"
import anushka_more from "../diaries-info/TyDiaries_2024/Anushka_More.jpg"
import shubhra_shevkar_2027 from "../diaries-info/TyDiaries_Batch_27/shubhra_shevkar.png";
import omkar_kale from "../diaries-info/TyDiaries_2025/omkar_kale.png"
import tanmay_patil from "../diaries-info/TyDiaries_2022/tanmay_patil.png";
import ritesh_chaudhari from "../diaries-info/TyDiaries_2023/Ritesh Chaudhari.jpeg";
import rachana_gade from "../diaries-info/TyDiaries_2023/rachana_gade.jpg";
import harshwardhan_deshmukh from "../diaries-info/TyDiaries_2024/Harshwardhan_Deshmukh.jpg"
import vasvi from "../diaries-info/vasvi_gupta.jpg";
import yashwant_bhosale_2027 from "../diaries-info/TyDiaries_Batch_27/yashwant_bhosale.png";
import mayank from "../diaries-info/mayank_jain.jpg";
import pratik_patil from "../diaries-info/TyDiaries_2023/Pratik Patil.jpg";
import mihika_dravid from "../diaries-info/TyDiaries_2023/Mihika Dravid.jpg";
import ansh_mehta_2027 from "../diaries-info/TyDiaries_Batch_27/ansh_mehta.png";
import utkarsha_gore from "../diaries-info/TyDiaries_2024/Utkarsha_Gore.jpg"
import sakshi_pawar from "../diaries-info/TyDiaries_2022/sakshi_pawar.jpg";
import anish_shetty from "../diaries-info/TyDiaries_2025/anish_shetty.png"
import saanvi_shet from "../diaries-info/TyDiaries_2025/saanvi_shet.png"
import anushka_naik from "../diaries-info/TyDiaries_2023/anushka_naik.jpg";
import shreya_bhatkhande from "../diaries-info/TyDiaries_2024/Shreya_Bhatkhande.jpg"
import gaurav from "../diaries-info/gaurav_wawdhane.jpg";
import rohit from "../diaries-info/rohit_choudhari.jpeg";
import apurva_haspe from "../diaries-info/TyDiaries_2024/Apurva_Haspe.jpg"
import sayalee_khedekar_2027 from "../diaries-info/TyDiaries_Batch_27/sayalee_khedekar.png";
import soham_naigaonkar from "../diaries-info/TyDiaries_2024/Soham_Naigaonkar.jpg"
import alhad_deodhar_2027 from "../diaries-info/TyDiaries_Batch_27/alhad_deodhar.png";
import samarth_kanwate from "../diaries-info/TyDiaries_2024/Samarth_Kanwate.jpg"
import aloki_upadhyay_2027 from "../diaries-info/TyDiaries_Batch_27/aloki_upadhyay.png";
import sahil_malawde_2027 from "../diaries-info/TyDiaries_Batch_27/sahil_malawde.png";
import ritik from "../diaries-info/TyDiaries_2022/ritik_naik.jpg";
import viraj from "../diaries-info/viraj_jadhav.jpg";
import saurabh_jog from "../diaries-info/TyDiaries_2023/saurabh_jog.jpg";
import smruti_pachpute from "../diaries-info/TyDiaries_2025/smruti_pachpute.png"
import vaishnavi_shelar from "../diaries-info/TyDiaries_2025/vaishnavi_shelar.png"
import siya_dhokane from "../diaries-info/TyDiaries_2022/siya_dhokane.jpg";
import prerna_tulsiani from "../diaries-info/TyDiaries_2023/Prerna Tulsiani.jpg";
import nimit_jain from "../diaries-info/TyDiaries_2022/nimit_jain.jpg";
import jinit from "../diaries-info/jinit_sanghvi.jpg";
import varun_kudtarkar_2027 from "../diaries-info/TyDiaries_Batch_27/varun_kudtarkar.png";
import yash_chandak from "../diaries-info/TyDiaries_2023/Yash Chandak.jpg";
import janhavi_jain_2027 from "../diaries-info/TyDiaries_Batch_27/janhavi_jain.png";
import anvita_mahajan from "../diaries-info/TyDiaries_2023/anvita_mahajan.jpg";
import suhas_dode from "../diaries-info/TyDiaries_2025/suhas_dode.png"
import payal_sankpal from "../diaries-info/TyDiaries_2025/payal_sankpal.png"
import aastha_jajoo_2027 from "../diaries-info/TyDiaries_Batch_27/aastha_jajoo.png";
import shruti_ravichandran from "../diaries-info/TyDiaries_2024/Shruti_Ravichandran.jpg"
import sreya_sudheeran_2027 from "../diaries-info/TyDiaries_Batch_27/sreya_sudheeran.png";
import sejal_pathak_2027 from "../diaries-info/TyDiaries_Batch_27/sejal_pathak.png";
import sofiya_rukadikar_2027 from "../diaries-info/TyDiaries_Batch_27/sofiya_rukadikar.png";
import keertivarma_2027 from "../diaries-info/TyDiaries_Batch_27/keertivarma.png";
import isha_khutafale from "../diaries-info/TyDiaries_2025/isha_khutafale.png"
import aneesh_phatak_2027 from "../diaries-info/TyDiaries_Batch_27/aneesh_phatak.png";
import vaishnavi_badgujar from "../diaries-info/TyDiaries_2024/Vaishnavi_Badgujar.jpg"
import pratham_tandale from "../diaries-info/TyDiaries_2025/pratham_tandale.png"
import hrishikesh from "../diaries-info/hrishikesh_athalye.png";
import ankita_karhade_2027 from "../diaries-info/TyDiaries_Batch_27/ankita_karhade.png";
import anushka_tadphale from "../diaries-info/TyDiaries_2022/anushka_tadphale.jpg";
import aditya_raskar from "../diaries-info/TyDiaries_2024/Aditya_Raskar.jpg"
import purav_desai from "../diaries-info/TyDiaries_2022/purav_desai.jpg"
import ankita from "../diaries-info/ankita_vaid.jpg";
import sakshi_mahajan from "../diaries-info/TyDiaries_2024/Sakshi_Mahajan.jpg"
import sayali_patil from "../diaries-info/TyDiaries_2022/sayali_patil.jpg";
import sagar_satbhai_2027 from "../diaries-info/TyDiaries_Batch_27/sagar_satbhai.png";
import om_khare from "../diaries-info/TyDiaries_2023/om_khare.jpeg";
import srushti_gadale from "../diaries-info/TyDiaries_2025/srushti_gadale.png"
import aveena_dange from "../diaries-info/TyDiaries_2025/aveena_dange.png"
import rukmini_nazre from "../diaries-info/TyDiaries_2024/Rukmini_Nazre.jpg"
import vadiraj_joshi from "../diaries-info/TyDiaries_2024/Vadiraj_Joshi.jpg"
import mugdha from "../diaries-info/mugdha_bapat.jpg";
import anish_deshpande from "../diaries-info/TyDiaries_2023/Anish Deshpande.jpg";
import mudit_bapna from "../diaries-info/TyDiaries_2022/mudit_bapna.jpg";
import avadhoot_ghewade from "../diaries-info/TyDiaries_2025/avadhoot_ghewade.png"
import rajvee_shah_2027 from "../diaries-info/TyDiaries_Batch_27/rajvee_shah.png";
import arsh_maknojia from "../diaries-info/TyDiaries_2024/Arsh_Maknojia.jpg"
import bhagyashree_patil_2027 from "../diaries-info/TyDiaries_Batch_27/bhagyashree_patil.png";
import onkar_bhagwat from "../diaries-info/TyDiaries_2025/onkar_bhawat.png"
import anshul_shelokar from "../diaries-info/TyDiaries_2025/anshul_shelokar.png"
import archisha_shukla from "../diaries-info/TyDiaries_2022/archisha_shukla.png";
import mihika_sanghvi from "../diaries-info/TyDiaries_2023/mihika_sanghvi.jpg";
import viren from "../diaries-info/viren_patil.jpg";
import gauri_kale_2027 from "../diaries-info/TyDiaries_Batch_27/gauri_kale.png";
import shyam_aradhye from "../diaries-info/TyDiaries_2023/Shyam Aradhye.png";
import renuka_padalkar from "../diaries-info/TyDiaries_2024/Renuka_Padalkar.jpg"
import tanmay_karad_2027 from "../diaries-info/TyDiaries_Batch_27/tanmay_karad.png";
import anagha_mahure from "../diaries-info/TyDiaries_2024/Anagha_Mahure.jpg"
import jia_johnson from "../diaries-info/TyDiaries_2024/Jia_Johnson.jpg"
import aniket from "../diaries-info/aniket_jayateerth.jpg";
import shitij_agrawal from "../diaries-info/TyDiaries_2023/Shitij Agrawal.jpg";
import sanika_kulkarni from "../diaries-info/TyDiaries_2024/Sanika_Kulkarni.jpg"
import shubham_gandhi from "../diaries-info/TyDiaries_2023/shubham_gandhi.png";
import sarthika_kashmire_2027 from "../diaries-info/TyDiaries_Batch_27/sarthika_kashmire.png";
import esha from "../diaries-info/eesha_kurode.jpg";
import tanuja_patil from "../diaries-info/TyDiaries_2025/tanuja_patil.png"
import ashutosh_pardeshi from "../diaries-info/TyDiaries_2022/ashutosh_pardeshi.png";
import anvay_joshi from "../diaries-info/TyDiaries_2024/Anvay_Joshi.jpg"
import yash_shah from "../diaries-info/yash_shah.png";
import suyog_arlimar from "../diaries-info/TyDiaries_2025/suyog_arlimar.jpg"
import muskan from "../diaries-info/muskan_paryani.png";
import chinmay_sheth from "../diaries-info/TyDiaries_2024/Chinmay_Sheth.jpg"
import onkar_wagh from "../diaries-info/TyDiaries_2024/Onkar_Wagh.jpg"
import saurabh_deulkar from "../diaries-info/TyDiaries_2025/saurabh_deulkar.png"
import tanmayee from "../diaries-info/TyDiaries_2022/tanmayee.jpg"
import davis_jojy_2027 from "../diaries-info/TyDiaries_Batch_27/davis_jojy.png";
import vrinda from "../diaries-info/vrinda_ahuja.jpeg";
import aditya from "../diaries-info/TyDiaries_2022/aditya_verma.png";
import atharv from "../diaries-info/atharva_phand.jpg";
import avdhut_kamble from "../diaries-info/TyDiaries_2024/Avdhut_Kamble.jpg"
import hakimuddin_slatewala_2027 from "../diaries-info/TyDiaries_Batch_27/hakimuddin_slatewala.png";
import abhinav from "../diaries-info/abhinav_roy.jpeg";
import shripad_kulkarni_2027 from "../diaries-info/TyDiaries_Batch_27/shripad_kulkarni.png";
import lizna_charaniya from "../diaries-info/TyDiaries_2025/lizna_charaniya.png"
import pratik_kardile from "../diaries-info/TyDiaries_2025/pratik_kardile.png"
import atharva_muglikar from "../diaries-info/TyDiaries_2023/atharva_muglikar.jpeg";
import ketan_kale from "../diaries-info/TyDiaries_2024/Ketan_Kale.jpg"
import sohel_bargir from "../diaries-info/TyDiaries_2024/Sohel_Bargir.png"
import pallavi_buwa from "../diaries-info/TyDiaries_2022/pallavi_buwa.jpg";
import apurva_palwe_2027 from "../diaries-info/TyDiaries_Batch_27/apurva_palwe.png";
import samruddhi_kamthe from "../diaries-info/TyDiaries_2023/Samruddhi Kamthe.jpeg";
import aayush from "../diaries-info/ayush_shah.jpg";
import vaishnavi_pabalkar from "../diaries-info/TyDiaries_2023/Vaishnavi Pabalkar.jpeg";
import aman_morghade_2027 from "../diaries-info/TyDiaries_Batch_27/aman_morghade.png";
import moin_shaikh_2027 from "../diaries-info/TyDiaries_Batch_27/moin_shaikh.png";
import sayali_mate from "../diaries-info/TyDiaries_2023/Sayali Mate.jpeg";
import ishan_patwardhan from "../diaries-info/TyDiaries_2023/Ishan Patwardhan.png";
import harshal_kausadikar from "../diaries-info/TyDiaries_2023/harshal_kausadikar.jpg";
import vishwesh from "../diaries-info/TyDiaries_2022/vishwesh_pujari.jpg";
import quasim_shaikh from "../diaries-info/TyDiaries_2023/quasim_shaikh.png";
import rujuta_budke from "../diaries-info/TyDiaries_2024/Rujuta_Budke.jpg"
import savan from "../diaries-info/savan_nahar.jpg";
import prajwal_bhosale from "../diaries-info/TyDiaries_2025/prajwal_bhosale.jpg"
import paras_dhole from "../diaries-info/TyDiaries_2025/paras_dhole.png"
import umang from "../diaries-info/umang_sakhare.jpg";
import chinmay_barve from "../diaries-info/TyDiaries_2025/chinmay_barve.png"
import anup from "../diaries-info/anup_nair.jpg";
import swapna_khare_2027 from "../diaries-info/TyDiaries_Batch_27/swapna_khare.png";
import shreeya_ganji from "../diaries-info/TyDiaries_2024/Shreeya_Ganji.jpg"
import omkar_oak from "../diaries-info/TyDiaries_2024/Omkar_Oak.jpg"
import ujwal_kitchloo_2027 from "../diaries-info/TyDiaries_Batch_27/ujwal_kitchloo.png";
import siddhi_pawar_2027 from "../diaries-info/TyDiaries_Batch_27/siddhi_pawar.png";
import pratyay_dhond from "../diaries-info/TyDiaries_2024/Pratyay_Dhond.jpeg";
import mayur_k from "../diaries-info/TyDiaries_2023/Mayur Kongutte.jpg";
import paras_anbhule_2027 from "../diaries-info/TyDiaries_Batch_27/paras_anbhule.png";
import nikita_tipule from "../diaries-info/TyDiaries_2022/nikita_tipule.png";
import arya from "../diaries-info/arya_gandhi.jpg";
import sayali_khedkar from "../diaries-info/TyDiaries_2025/sayali_khedkar.png"
import shriya_kale from "../diaries-info/TyDiaries_2024/Shriya_Kale.jpg"
import swebert from "../diaries-info/swebert_correa.jpg";
import sehajdeep_singh from "../diaries-info/TyDiaries_2023/sehajdeep_singh.jpg";
import vedang_khedekar from "../diaries-info/TyDiaries_2024/Vedang_Khedekar.jpg"
import amruni_mehta from "../diaries-info/TyDiaries_2025/amruni_mehta.png"
import sarthak_pawar from "../diaries-info/TyDiaries_2025/sarthak_pawar.png"
import sarvesh_mankar from "../diaries-info/TyDiaries_2024/Sarvesh_Mankar.jpg"
import jay_kolhe from "../diaries-info/TyDiaries_2025/jay_kolhe.png"
import snehasish_bose from "../diaries-info/TyDiaries_2024/Snehasish_Bose.jpg"
import piyush_deshpande from "../diaries-info/TyDiaries_2025/piyush_deshpande.png"
import nachiket_deshmukh from "../diaries-info/TyDiaries_2024/Nachiket_Deshmukh.jpg"
import ketaki_jadhav from "../diaries-info/TyDiaries_2022/ketaki_jadhav.jpg";
import shweta_jadhav_2027 from "../diaries-info/TyDiaries_Batch_27/shweta_jadhav.png";
import atharva_marathe from "../diaries-info/TyDiaries_2022/atharva_marathe.jpg";
import abhinav_kurule from "../diaries-info/TyDiaries_2024/Abhinav_Kurule.jpg"
import suraj_sonawane_2027 from "../diaries-info/TyDiaries_Batch_27/suraj_sonawane.png";
import aalokkumar from "../diaries-info/TyDiaries_2025/aalokkumar.png"
import viraj_nalbarwar_2027 from "../diaries-info/TyDiaries_Batch_27/viraj_nalbalwar.png";
import idris_adeeb from "../diaries-info/TyDiaries_2025/idris_adeeb.png"
import aman_sayyad from "../diaries-info/TyDiaries_2024/Aman_Sayyad.jpg"
import rohit_magar from "../diaries-info/TyDiaries_2023/rohit_magar.jpg";
import chirag_ingale from "../diaries-info/TyDiaries_2025/chirag_ingale.png"
import dhanashree_mahadeo from "../diaries-info/TyDiaries_2023/dhanashree_mahadeo.jpg";
import vishwajit_kadam from "../diaries-info/TyDiaries_2022/vishwajit_kadam.jpg";
import anjali_dofe from "../diaries-info/TyDiaries_2022/anjali_dofe.jpg";
import yash_hodlur from "../diaries-info/TyDiaries_2025/yash_hodlur.png"
import soham from "../diaries-info/soham_parekh.jpg";
import arshiya_kazi_2027 from "../diaries-info/TyDiaries_Batch_27/arshiya_kazi.png";
import saee_chavan_2027 from "../diaries-info/TyDiaries_Batch_27/saee_chavan.png";
import atharv_munot from "../diaries-info/TyDiaries_2025/atharv_munot.png"
import arnav_singhal_2027 from "../diaries-info/TyDiaries_Batch_27/arnav_singhal.png";
import naman from "../diaries-info/naman_modi.jpg";
import soumyajit_das from "../diaries-info/TyDiaries_2025/soumyajit_das.png"
import sakshi_powar from "../diaries-info/TyDiaries_2025/sakshi_powar.png"
import soham_gupte from "../diaries-info/TyDiaries_2024/soham_gupte.jpg";
import aneesh_topkar_2027 from "../diaries-info/TyDiaries_Batch_27/aneesh_topkar.png";


// Company Logo IMPORTS 
import npcilogo from "../img/company-logos/npci_logo.png"
import ideaslogo from "../img/company-logos/ideas_logo.png"
import UBSlogo from "../img/company-logos/UBS.png"
import CarrotSoftlogo from "../img/company-logos/CarrotSoft-logo.png"
import Siemenslogo from "../img/company-logos/Siemens-logo.png"
import Algoquantlogo from "../img/company-logos/Algoquant-logo.png"
import bplogo from "../img/company-logos/british_petroleum_logo.png"
import MarvellLogo from "../img/company-logos/Marvell-logo.png"
import TradingLogo from "../img/company-logos/Trading-logo.png"
import PatternLogo from "../img/company-logos/pattern-logo.png"
import HiltiLogo from "../img/company-logos/hilti.jpg"
import BarclaysLogo from "../img/company-logos/barclays-logo.png"
import DEShawLogo from "../img/company-logos/DEShaw-logo.png"
import ArcesiumLogo from "../img/company-logos/Arcesium-logo.png"
import GoldmanSachsLogo from "../img/company-logos/GoldmanSachs-logo.png"
import WoltersKluwerLogo from "../img/company-logos/WoltersKluwer-logo.png"
import StandardCharteredLogo from "../img/company-logos/StandardChartered-logo.png"
import CreditSuisseLogo from "../img/company-logos/CreditSuisse-logo.png"
import FinIQLogo from "../img/company-logos/FinIQ-logo.png"
import MastercardLogo from "../img/company-logos/Mastercard-logo.png"
import QuestionProLogo from "../img/company-logos/QuestionPro-logo.png"
import GarrettMotionLogo from "../img/company-logos/GarrettMotion-logo.png"
import eQLogo from "../img/company-logos/eQ-logo.png"
import NuanceLogo from "../img/company-logos/Nuance-logo.png"
import CitiLogo from "../img/company-logos/citi-logo.png"
import GoogleLogo from "../img/company-logos/google-logo.png"
import SchlumbergerLogo from "../img/company-logos/Schlumberger-logo.png"
import DeutscheLogo from "../img/company-logos/deutsche-logo.png"
import Persistent from "../img/company-logos/persistent.png"
import WellsFargo from "../img/company-logos/wells_fargo_logo.png"
import TcsLogo from "../img/company-logos/tcs_logo.png"
import InxiseLogo from "../img/company-logos/Inxise-logo.png"
import Colgate_palmolive from "../img/company-logos/colPalm.png"
import JPMLogo from "../img/company-logos/JPM.png"
import BNYLogo from "../img/company-logos/BNYM.png"
import HSBCLogo from "../img/company-logos/HSBC.png"
import NvidiaLogo from "../img/company-logos/nvidia-logo.png"
import SiemensLogo from "../img/company-logos/Siemens-logo.png"
import TexasLogo from "../img/company-logos/TILogo.png"
import AccentureLogo from "../img/company-logos/Accenture.png"



// HTML IMPORTS 
import aniket_ware_2027_html from "../diaries-info/TyDiaries_Batch_27/aniket_ware.js";
import saee_chavan_2027_html from "../diaries-info/TyDiaries_Batch_27/saee_chavan.js";
import anuksha_koul_html from "../diaries-info/TyDiaries_2024/anuksha_koul.js"
import mayank_html from "../diaries-info/mayank_jain";
import sakshi_powar_html from "../diaries-info/TyDiaries_2025/Sakshi_powar.js"
import vaishnavi_shelar_html from "../diaries-info/TyDiaries_2025/vaishnavi_shelar.js"
import swebert_html from "../diaries-info/swebert_correa.js";
import anushka_naik_html from "../diaries-info/TyDiaries_2023/anushka_naik";
import anish_deshpande_html from "../diaries-info/TyDiaries_2023/anish_deshpande";
import soham_kumthekar_html from "../diaries-info/TyDiaries_2024/soham_kumthekar.js"
import pratyay_dhond_html from "../diaries-info/TyDiaries_2024/Pratyay_Dhond";
import soham_html from "../diaries-info/soham_parekh.js";
import isha_khutafale_html from "../diaries-info/TyDiaries_2025/isha_khutafale.js"
import arya_html from "../diaries-info/arya_gandhi";
import arsh_maknojia_html from "../diaries-info/TyDiaries_2024/arsh_maknojia.js"
import ashutosh_pardeshi_html from "../diaries-info/TyDiaries_2022/ashutosh_pardeshi";
import mihika_sanghvi_html from "../diaries-info/TyDiaries_2023/mihika_sanghvi";
import lizna_charaniya_html from "../diaries-info/TyDiaries_2025/LiznaNuruddinCharaniya.jsx"
import kartik_mandhan_html from "../diaries-info/TyDiaries_2022/kartik_mandhan";
import mugdha_html from "../diaries-info/mugdha_bapat";
import avishkar_andhale_html from "../diaries-info/TyDiaries_2022/avishkar_andhale";
import chinmay_barve_html from "../diaries-info/TyDiaries_2025/chinmay_barve.js"
import sharvari_phand_html from "../diaries-info/TyDiaries_2024/sharvari_phand.js"
import vedang_khedekar_html from "../diaries-info/TyDiaries_2024/vedang_khedekar.js"
import varun_kudtarkar_2027_html from "../diaries-info/TyDiaries_Batch_27/varun_kudtarkar.js";
import rujuta_budke_html from "../diaries-info/TyDiaries_2024/rujuta_budke.js"
import aloki_upadhyay_2027_html from "../diaries-info/TyDiaries_Batch_27/aloki_upadhyay.js";
import rhugaved_html from "../diaries-info/rhugaved_narmade.js";
import omkar_html from "../diaries-info/omkar_thorat";
import jia_johnson_html from "../diaries-info/TyDiaries_2024/jia_johnson.js"
import vishwajit_kadam_html from "../diaries-info/TyDiaries_2022/vishwajit_kadam";
import avadhoot_ghewade_html from "../diaries-info/TyDiaries_2025/avadhoot_ghewade.js"
import anvay_joshi_html from "../diaries-info/TyDiaries_2024/anvay_joshi.js"
import harsh_pande_html from "../diaries-info/TyDiaries_2023/harsh_pande";
import soumyajit_das_html from "../diaries-info/TyDiaries_2025/soumyajit_das.js"
import soham_laghate_html from "../diaries-info/TyDiaries_2025/soham_laghate.js"
import shreeya_ganji_html from "../diaries-info/TyDiaries_2024/shreeya_ganji.js"
import aastha_jajoo_2027_html from "../diaries-info/TyDiaries_Batch_27/aastha_jajoo.js";
import sreya_sudheeran_2027_html from "../diaries-info/TyDiaries_Batch_27/sreya_sudheeran.js";
import soumya_pachpor_2027_html from "../diaries-info/TyDiaries_Batch_27/soumya_pachpor.js";
import ketan_kale_html from "../diaries-info/TyDiaries_2024/ketan_kale.js"
import rohit_magar_html from "../diaries-info/TyDiaries_2023/rohit_magar";
import akshita_dhoot_html from "../diaries-info/TyDiaries_2025/akshita_dhoot.js"
import chinmay_html from "../diaries-info/chinmay_dixit";
import mansi_kumar_html from "../diaries-info/TyDiaries_2025/mansi_kumar.js"
import snehasish_bose_html from "../diaries-info/TyDiaries_2024/snehasish_bose.js"
import krushna_bankar_2027_html from "../diaries-info/TyDiaries_Batch_27/krushna_bankar.js";
import disha_kadam_2027_html from "../diaries-info/TyDiaries_Batch_27/disha_kadam.js";
import yash_shah_html from "../diaries-info/yash_shah";
import shyam_aradhye_html from "../diaries-info/TyDiaries_2023/shyam_aradhye"
import shriya_kale_html from "../diaries-info/TyDiaries_2024/shriya_kale.js"
import umang_sakhare_html from "../diaries-info/umang_sakhare";
import ishita_gaikwad_html from "../diaries-info/TyDiaries_2025/ishita.js"
import anvita_mahajan_html from "../diaries-info/TyDiaries_2023/anvita_mahajan";
import harish_html from "../diaries-info/TyDiaries_2022/harish_choudhary";
import quasim_shaikh_html from "../diaries-info/TyDiaries_2023/quasim_shaikh";
import vaishnavi_shambharkar_2027_html from "../diaries-info/TyDiaries_Batch_27/vaishnavi_shambharkar.js";
import yash_gangwar_html from "../diaries-info/yash_gangwar";
import aditya_html from "../diaries-info/TyDiaries_2022/aditya_verma";
import ansh_mehta_2027_html from "../diaries-info/TyDiaries_Batch_27/ansh_mehta.js";
import riya_kulkarni_2027_html from "../diaries-info/TyDiaries_Batch_27/riya_kulkarni.js";
import sayali_mate_html from "../diaries-info/TyDiaries_2023/sayali_mate";
import nimit_html from "../diaries-info/TyDiaries_2022/nimit_jain";
import sarthika_kashmire_2027_html from "../diaries-info/TyDiaries_Batch_27/sarthika_kashmire.js";
import arya_kulkarni_2027_html from "../diaries-info/TyDiaries_Batch_27/arya_kulkarni.js";
import sakshi_pawar_html from "../diaries-info/TyDiaries_2022/sakshi_pawar";
import rohit_html from "../diaries-info/rohit_chaudhari";
import shubhra_shevkar_2027_html from "../diaries-info/TyDiaries_Batch_27/shubhra_shevkar.js";
import mihika_dravid_html from "../diaries-info/TyDiaries_2023/mihika_dravid"
import atharva_muglikar_html from "../diaries-info/TyDiaries_2023/atharva_muglikar";
import samarth_kanwate_html from "../diaries-info/TyDiaries_2024/samarth_kanwate.js"
import aditya_raskar_html from "../diaries-info/TyDiaries_2024/aditya_raskar.js"
import kaustubh_kharat_html from "../diaries-info/TyDiaries_2025/kaustubh_kharat.js"
import soham_dombale_html from "../diaries-info/TyDiaries_2024/soham_dombale.js"
import atharva_satav_html from "../diaries-info/TyDiaries_2024/atharva_satav.js"
import swapna_khare_2027_html from "../diaries-info/TyDiaries_Batch_27/swapna_khare.js";
import suhas_dode_html from "../diaries-info/TyDiaries_2025/suhas_dode.js"
import minautee_dighe_2027_html from "../diaries-info/TyDiaries_Batch_27/minautee_dighe.js";
import ankita_html from "../diaries-info/ankita_vaid";
import hakimuddin_slatewala_2027_html from "../diaries-info/TyDiaries_Batch_27/hakimuddin_slatewala.js";
import arshiya_kazi_2027_html from "../diaries-info/TyDiaries_Batch_27/arshiya_kazi.js";
import yashwant_bhosale_2027_html from "../diaries-info/TyDiaries_Batch_27/yashwant_bhosale.js";
import anjali_html from "../diaries-info/TyDiaries_2022/anjali_dofe";
import nidhi_patel_html from "../diaries-info/TyDiaries_2023/nidhi_patel";
import shubham_gupta_html from "../diaries-info/TyDiaries_2024/shubham_gupta.js"
import sofiya_rukadikar_2027_html from "../diaries-info/TyDiaries_Batch_27/sofiya_rukadikar.js";
import aman_morghade_2027_html from "../diaries-info/TyDiaries_Batch_27/aman_morghade.js";
import aditya_choudhary_html from "../diaries-info/TyDiaries_2024/aditya_choudhary.js"
import atharva_sardesai_html from "../diaries-info/TyDiaries_2025/Atharva_sardesai.js"
import vaishnavi_mulik_html from "../diaries-info/TyDiaries_2024/vaishnavi_mulik.js"
import sarvesh_mankar_html from "../diaries-info/TyDiaries_2024/sarvesh_mankar.js"
import saurabh_deulkar_html from "../diaries-info/TyDiaries_2025/saurabh_deulkar.js"
import apurva_haspe_html from "../diaries-info/TyDiaries_2024/apurva_haspe.js"
import aditya_deshmukh_html from "../diaries-info/TyDiaries_2025/aditya_deshmukh.js"
import payal_sankpal_html from "../diaries-info/TyDiaries_2025/payal_sankpal.js"
import gauri_kale_2027_html from "../diaries-info/TyDiaries_Batch_27/gauri_kale.js";
import purav_desai_html from "../diaries-info/TyDiaries_2022/purav_desai";
import aditya_naik_html from "../diaries-info/TyDiaries_2023/aditya_naik"
import arnav_gavde_html from "../diaries-info/TyDiaries_2025/arnav_gavade.js"
import yash_suryawanshi_html from "../diaries-info/TyDiaries_2023/yash_suryawanshi";
import saanvi_shet_html from "../diaries-info/TyDiaries_2025/SaanviRohanShet.jsx"
import christy_biju_html from "../diaries-info/TyDiaries_2023/christy_biju";
import atharv_html from "../diaries-info/atharva_phand";
import ayush_ambhorkar_html from "../diaries-info/TyDiaries_2024/ayush_ambhorkar.js"
import tanuja_patil_html from "../diaries-info/TyDiaries_2025/tanuja_patil.js"
import soham_gupte_html from "../diaries-info/TyDiaries_2024/soham_gupte";
import yash_chandak_html from "../diaries-info/TyDiaries_2023/yash_chandak";
import riti_panganti_html from "../diaries-info/TyDiaries_2025/riti.js"
import savan_nahar_html from "../diaries-info/savan_nahar";
import apurva_palwe_2027_html from "../diaries-info/TyDiaries_Batch_27/apurva_palwe.js";
import alhad_deodhar_2027_html from "../diaries-info/TyDiaries_Batch_27/alhad_deodhar.js";
import sahil_malawde_2027_html from "../diaries-info/TyDiaries_Batch_27/sahil_malawde.js";
import vaishnavi_pabalkar_html from "../diaries-info/TyDiaries_2023/vaishnavi_pabalkar";
import dhruv_sadhale_html from "../diaries-info/TyDiaries_2025/dhruv_sadhale.js"
import dhanashree_mahadeo_html from "../diaries-info/TyDiaries_2023/dhanashree_mahadeo";
import mehmood_deshmukh_2027_html from "../diaries-info/TyDiaries_Batch_27/mehmood_deshmukh.js";
import vaishnavi_badgujar_html from "../diaries-info/TyDiaries_2024/vaishnavi_badgujar.js"
import renuka_padalkar_html from "../diaries-info/TyDiaries_2024/renuka_padalkar.js"
import srushti_gadale_html from "../diaries-info/TyDiaries_2025/srushti_gadale.js"
import sejal_pathak_2027_html from "../diaries-info/TyDiaries_Batch_27/sejal_pathak.js";
import siya_dhokane_html from "../diaries-info/TyDiaries_2022/siya_dhokane";
import vasvi_html from "../diaries-info/vasvi_gupta.js";
import atharv_munot_html from "../diaries-info/TyDiaries_2025/atharv.js"
import siddhi_landage_2027_html from "../diaries-info/TyDiaries_Batch_27/siddhi_landage.js";
import shirshak_tiple_html from "../diaries-info/TyDiaries_2024/shirshak_tiple.js"
import aalokkumar_html from "../diaries-info/TyDiaries_2025/Aalokkumar_jaiswal.js"
import prajakta_html from "../diaries-info/TyDiaries_2022/prajakta_ghatage";
import jay_kolhe_html from "../diaries-info/TyDiaries_2025/jay_kolhe.js"
import arya_kulkarnia8_2027_html from "../diaries-info/TyDiaries_Batch_27/arya_kulkarnia8.js";
import shantanu_benake_2027_html from "../diaries-info/TyDiaries_Batch_27/shantanu_benake.js";
import aveena_dange_html from "../diaries-info/TyDiaries_2025/aveena_dange.js"
import preet_trivedi_html from "../diaries-info/TyDiaries_2024/preet_trivedi.js"
import archisha_html from "../diaries-info/TyDiaries_2022/archisha_shukla";
import aayush_html from "../diaries-info/ayush_shah";
import akansha_patil_2027_html from "../diaries-info/TyDiaries_Batch_27/akansha_patil.js";
import sayalee_khedekar_2027_html from "../diaries-info/TyDiaries_Batch_27/sayalee_khedekar.js";
import riddhi_html from "../diaries-info/TyDiaries_2022/riddhi_tharewal";
import ketaki_jadhav_html from "../diaries-info/TyDiaries_2022/ketaki_jadhav";
import nikhil_kokale_html from "../diaries-info/TyDiaries_2024/nikhil_kokale.js"
import shraddha_darade_html from "../diaries-info/TyDiaries_2025/shraddha.js"
import chitra_sangle_html from "../diaries-info/TyDiaries_2023/chitra_sangle"
import sarthak_pawar_html from "../diaries-info/TyDiaries_2025/sarthak_pawar.js"
import sayali_html from "../diaries-info/TyDiaries_2022/sayali_patil";
import omkar_oak_html from "../diaries-info/TyDiaries_2024/omkar_oak.js"
import janhavi_jain_2027_html from "../diaries-info/TyDiaries_Batch_27/janhavi_jain.js";
import gaurav_html from "../diaries-info/gaurav_wawdhane";
import hrishikesh_html from "../diaries-info/hrishikesh_athalye";
import parth_mane_html from "../diaries-info/TyDiaries_2024/parth_mane.js"
import deep_oak_html from "../diaries-info/TyDiaries_2025/deep_oak.js"
import shruti_ravichandran_html from "../diaries-info/TyDiaries_2024/shruti_ravichandran.js"
import shripad_kulkarni_2027_html from "../diaries-info/TyDiaries_Batch_27/shripad_kulkarni.js";
import bhagyashree_lomesh_patil_html from "../diaries-info/TyDiaries_2024/bhagyashree_patil.js"
import abhinav_kurule_html from "../diaries-info/TyDiaries_2024/abhinav_kurule.js"
import omkar_kale_html from "../diaries-info/TyDiaries_2025/Omkar_kale.js"
import sagar_satbhai_2027_html from "../diaries-info/TyDiaries_Batch_27/sagar_satbhai.js";
import chinmay_sheth_html from "../diaries-info/TyDiaries_2024/chinmay_sheth.js"
import naishadh_html from "../diaries-info/naishadh_vora";
import kaustubh_virkar_html from "../diaries-info/TyDiaries_2024/kaustubh_virkar.js"
import nachiket_deshmukh_html from "../diaries-info/TyDiaries_2024/nachiket_deshmukh.js"
import hardik_mutha_2027_html from "../diaries-info/TyDiaries_Batch_27/hardik_mutha.js";
import yash_pardeshi_html from "../diaries-info/TyDiaries_2025/yash_pardeshi.js"
import soumitra_html from "../diaries-info/soumitra_tonapi.js";
import anushka_more_html from "../diaries-info/TyDiaries_2024/anushka_more.js"
import vedanshi_shah_html from "../diaries-info/TyDiaries_2023/vedanshi_shah";
import arjun_deodhar_html from "../diaries-info/TyDiaries_2025/arjun_deodhar.js"
import siddhi_pawar_2027_html from "../diaries-info/TyDiaries_Batch_27/siddhi_pawar.js";
import falguni_html from "../diaries-info/falguni_patil";
import piyush_deshpande_html from "../diaries-info/TyDiaries_2025/piyush_deshpande.js"
import harsh_marke_html from "../diaries-info/TyDiaries_2024/harsh_marke.js"
import moin_shaikh_2027_html from "../diaries-info/TyDiaries_Batch_27/moin_shaikh.js";
import shloka_shinde_2027_html from "../diaries-info/TyDiaries_Batch_27/shloka_shinde.js";
import jayesh_html from "../diaries-info/TyDiaries_2022/jayesh";
import ninad_barve_html from "../diaries-info/TyDiaries_2023/ninad_barve";
import bhargav_gejji_html from "../diaries-info/TyDiaries_2025/bhargav_gejji.js"
import pallavi_html from "../diaries-info/TyDiaries_2022/pallavi_buwa";
import ritik_html from "../diaries-info/TyDiaries_2022/ritik_naik";
import tanmayee_html from "../diaries-info/TyDiaries_2022/tanmayee_bharati";
import viraj_nalbarwar_2027_html from "../diaries-info/TyDiaries_Batch_27/viraj_nalbalwar.js";
import parth_yewale_html from "../diaries-info/TyDiaries_2024/parth_yewale.js"
import suyog_arlimar_html from "../diaries-info/TyDiaries_2025/suyog_arlimar.js"
import sanmeet_html from "../diaries-info/TyDiaries_2022/sanmeet";
import shitij_agrawal_html from "../diaries-info/TyDiaries_2023/shitij_agrawal"
import anjali_phule_2027_html from "../diaries-info/TyDiaries_Batch_27/anjali_phule.js";
import bhagyashree_patil_2027_html from "../diaries-info/TyDiaries_Batch_27/bhagyashree_patil.js";
import shreya_bhatkhande_html from "../diaries-info/TyDiaries_2024/shreya_bhatkhande.js"
import simran_html from "../diaries-info/simran_kucheria";
import gaurish_dodke_html from "../diaries-info/TyDiaries_2024/gaurish_dodke.js"
import arnav_prasad_html from "../diaries-info/TyDiaries_2025/arnav_prasad.js"
import sanchit_rajmane_html from "../diaries-info/TyDiaries_2024/sanchit_rajmane.js"
import noopur_karkare_2027_html from "../diaries-info/TyDiaries_Batch_27/noopur_karkare.js";
import pratik_kardile_html from "../diaries-info/TyDiaries_2025/Pratik_kardile.js"
import idris_adeeb_html from "../diaries-info/TyDiaries_2025/idris_adeeb.js"
import vishwesh_html from "../diaries-info/TyDiaries_2022/vishwesh_pujari";
import harshal_kausadikar_html from "../diaries-info/TyDiaries_2023/harshal_kausadikar";
import nikita_tipule_html from "../diaries-info/TyDiaries_2022/nikita_tipule";
import darshan_shah_html from "../diaries-info/TyDiaries_2022/darshan_shah";
import samruddhi_kamthe_html from "../diaries-info/TyDiaries_2023/samruddhi_kamthe";
import sayali_khedkar_html from "../diaries-info/TyDiaries_2025/sayali_khedkar.js"
import om_khare_html from "../diaries-info/TyDiaries_2023/om_khare";
import sohel_bargir_html from "../diaries-info/TyDiaries_2024/Sohel_Bargir.js"
import rutuja_dautpure_html from "../diaries-info/TyDiaries_2025/rutuja_dautpure.js"
import anushka_tadphale_html from "../diaries-info/TyDiaries_2022/anushka_tadphale";
import vadiraj_joshi_html from "../diaries-info/TyDiaries_2024/vadiraj_joshi.js"
import eesha_html from "../diaries-info/eesha_kurode";
import arya_wankhede_html from "../diaries-info/TyDiaries_2025/arya_wankhede.js"
import deepika_html from "../diaries-info/deepika_goyal.js";
import ritesh_chaudhari_html from "../diaries-info/TyDiaries_2023/ritesh_chaudhari"
import muskan_html from "../diaries-info/muskaan_paryani.js";
import avdhut_kamble_html from "../diaries-info/TyDiaries_2024/avdhut_kamble.js"
import naman_html from "../diaries-info/naman_modi";
import apurva_deshpande_html from "../diaries-info/TyDiaries_2022/apurva_deshpande";
import tanmay_patil_html from "../diaries-info/TyDiaries_2022/tanmay_patil";
import prajwal_bhosale_html from "../diaries-info/TyDiaries_2025/prajwal_bhosale.js"
import rohit_shidid_html from "../diaries-info/TyDiaries_2023/rohit_shidid";
import onkar_bhagwat_html from "../diaries-info/TyDiaries_2025/onkar_bhagwat.js"
import shubham_gandhi_html from "../diaries-info/TyDiaries_2023/shubham_gandhi";
import saurabh_jog_html from "../diaries-info/TyDiaries_2023/saurabh_jog";
import gayatri_potbhare_2027_html from "../diaries-info/TyDiaries_Batch_27/gayatri_potbhare.js";
import sameer_kavthekar_html from "../diaries-info/TyDiaries_2022/sameer_kavthekar";
import shreya_vaidya_html from "../diaries-info/TyDiaries_2022/shreya_vaidya";
import onkar_wagh_html from "../diaries-info/TyDiaries_2024/onkar_wagh.js"
import paras_dhole_html from "../diaries-info/TyDiaries_2025/paras_dhole.js"
import harshal_html from "../diaries-info/harshal_patil";
import yash_hodlur_html from "../diaries-info/TyDiaries_2025/yash_hodlur.js"
import pratham_tandale_html from "../diaries-info/TyDiaries_2025/pratham_tandale.js"
import neha_pawar_html from "../diaries-info/TyDiaries_2023/neha_pawar";
import viren_html from "../diaries-info/viren_patil.js";
import omkar_nagwekar_html from "../diaries-info/TyDiaries_2024/omkar_nagwekar.js"
import soham_naigaonkar_html from "../diaries-info/TyDiaries_2024/soham_naigaonkar.js"
import vrinda_html from "../diaries-info/vrinda_ahuja";
import utkarsha_gore_html from "../diaries-info/TyDiaries_2024/utkarsha_gore.js"
import advait_karmalkar_html from "../diaries-info/TyDiaries_2023/advait_karmalkar";
import aman_patil_html from "../diaries-info/TyDiaries_2022/aman_patil";
import rukmini_nazre_html from "../diaries-info/TyDiaries_2024/rukmini_nazre.js"
import shreyas_katkar_html from "../diaries-info/TyDiaries_2025/shreyas_katkar.js"
import vasu_html from "../diaries-info/vasu_sharma.js";
import harshmohan_kulkarni_html from "../diaries-info/TyDiaries_2023/harshmohan_kulkarni";
import ujwal_kitchloo_2027_html from "../diaries-info/TyDiaries_Batch_27/ujwal_kitchloo.js";
import anish_shetty_html from "../diaries-info/TyDiaries_2025/anish_shetty.js"
import anagha_mahure_html from "../diaries-info/TyDiaries_2024/anagha_mahure.js"
import yash_shah_2027_html from "../diaries-info/TyDiaries_Batch_27/yash_shah.js";
import anup_html from "../diaries-info/anup_nair.js";
import aman_sayyad_html from "../diaries-info/TyDiaries_2024/aman_sayyad.js"
import shweta_jadhav_2027_html from "../diaries-info/TyDiaries_Batch_27/shweta_jadhav.js";
import aniket_html from "../diaries-info/aniket_jayateerth.js";
import rachana_gade_html from "../diaries-info/TyDiaries_2023/rachana_gade";
import siddhi_shinde_html from "../diaries-info/TyDiaries_2023/siddhi_shinde"
import manas_html from "../diaries-info/manas_nighrunkar";
import aneesh_topkar_2027_html from "../diaries-info/TyDiaries_Batch_27/aneesh_topkar.js";
import keertivarma_2027_html from "../diaries-info/TyDiaries_Batch_27/keertivarma.js";
import sakshi_mahajan_html from "../diaries-info/TyDiaries_2024/sakshi_mahajan.js"
import arnav_singhal_2027_html from "../diaries-info/TyDiaries_Batch_27/arnav_singhal.js";
import paras_anbhule_2027_html from "../diaries-info/TyDiaries_Batch_27/paras_anbhule.js";
import sandesh_sahane_html from "../diaries-info/TyDiaries_2024/sandesh_sahane.js"
import jinit_html from "../diaries-info/jinit_sanghvi.js";
import chetas_html from "../diaries-info/chetas_borse.js";
import mruganksha_kudake_2027_html from "../diaries-info/TyDiaries_Batch_27/mruganksha_kudake.js";
import atharva_marathe_html from "../diaries-info/TyDiaries_2022/atharva_marathe";
import davis_jojy_2027_html from "../diaries-info/TyDiaries_Batch_27/davis_jojy.js";
import shreya_singhal_html from "../diaries-info/shreya_singhal";
import viraj_html from "../diaries-info/viraj_jadhav.js";
import amruni_mehta_html from "../diaries-info/TyDiaries_2025/amruni_mehta.js"
import tanmay_karad_2027_html from "../diaries-info/TyDiaries_Batch_27/tanmay_karad.js";
import chirag_ingale_html from "../diaries-info/TyDiaries_2025/chirag_ingale.js"
import himanshu_kamdi_html from "../diaries-info/TyDiaries_2024/himanshu_kamdi.js"
import kunal_chaudhari_html from "../diaries-info/TyDiaries_2022/kunal_chaudhari";
import simran_veer_html from "../diaries-info/TyDiaries_2024/simran_veer.js"
import mudit_bapna_html from "../diaries-info/TyDiaries_2022/mudit_bapna";
import aneesh_phatak_2027_html from "../diaries-info/TyDiaries_Batch_27/aneesh_phatak.js";
import harshwardhan_deshmukh_html from "../diaries-info/TyDiaries_2024/harshwardhan_deshmukh.js"
import abhinav_html from "../diaries-info/abhinav_roy";
import aashay_inamdar_html from "../diaries-info/TyDiaries_2025/aashay_inamdar.js"
import sanika_kulkarni_html from "../diaries-info/TyDiaries_2024/sanika_kulkarni.js"
import smruti_pachpute_html from "../diaries-info/TyDiaries_2025/smruti_pachpute.js"
import suswan_joglekar_2027_html from "../diaries-info/TyDiaries_Batch_27/suswan_joglekar.js";
import sahil_tejwani_2027_html from "../diaries-info/TyDiaries_Batch_27/sahil_tejwani.js";
import anshul_shelokar_html from "../diaries-info/TyDiaries_2025/anshul_shelokar.js"
import nishant_agte_2027_html from "../diaries-info/TyDiaries_Batch_27/nishant_agte.js";
import ishan_patwardhan_html from "../diaries-info/TyDiaries_2023/ishan_patwardhan"
import prerna_tulsiani_html from "../diaries-info/TyDiaries_2023/prerna_tulsiani";
import rajvee_shah_2027_html from "../diaries-info/TyDiaries_Batch_27/rajvee_shah.js";
import sneha_venk_html from "../diaries-info/TyDiaries_2023/sneha_venk";
import sehajdeep_singh_html from "../diaries-info/TyDiaries_2023/sehajdeep_singh";
import tanishq_borkar_2027_html from "../diaries-info/TyDiaries_Batch_27/tanishq_borkar.js";
import pratik_patil_html from "../diaries-info/TyDiaries_2023/pratik_patil"
import aryan_mehta_2027_html from "../diaries-info/TyDiaries_Batch_27/aryan_mehta.js";
import suraj_sonawane_2027_html from "../diaries-info/TyDiaries_Batch_27/suraj_sonawane.js";
import ankita_karhade_2027_html from "../diaries-info/TyDiaries_Batch_27/ankita_karhade.js";
import atharva_mutsaddi_html from "../diaries-info/TyDiaries_2024/atharva_mutsaddi.js"
import mayur_kongutte_html from "../diaries-info/TyDiaries_2023/mayur_kongutte"



//Entire TY Diaries data: 
export let data = [
    {
        company: "TCS Research",
        logo: TcsLogo,
        isUpdated: false,
        batches: [
            "2025"
        ],
        interns: [
            {
                image: shirshak_tiple,
                firstname: "Shirshak",
                lastname: "Tiple",
                html: shirshak_tiple_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: nachiket_deshmukh,
                firstname: "Nachiket",
                lastname: "Deshmukh",
                html: nachiket_deshmukh_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: rukmini_nazre,
                firstname: "Rukmini",
                lastname: "Nazre",
                html: rukmini_nazre_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            }
        ]
    },
    {
        company: "CITI",
        logo: CitiLogo,
        isUpdated: true,
        batches: [
            "2022",
            "2023",
            "2024",
            "2025",
            "2026",
            "2027"
        ],
        interns: [
            {
                image: anish_shetty,
                firstname: "Anish",
                lastname: "Shetty",
                html: anish_shetty_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: akshita_dhoot,
                firstname: "Akshita",
                lastname: "Dhoot",
                html: akshita_dhoot_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: kaustubh_kharat,
                firstname: "Kaustubh",
                lastname: "Kharat",
                html: kaustubh_kharat_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: pratik_kardile,
                firstname: "Pratik",
                lastname: "Kardile",
                html: pratik_kardile_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: rutuja_dautpure,
                firstname: "Rutuja",
                lastname: "Dautpure",
                html: rutuja_dautpure_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: suhas_dode,
                firstname: "Suhas",
                lastname: "Dode",
                html: suhas_dode_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: saurabh_deulkar,
                firstname: "Saurabh",
                lastname: "Deulkar",
                html: saurabh_deulkar_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: yash_pardeshi,
                firstname: "Yash",
                lastname: "Pardeshi",
                html: yash_pardeshi_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: himanshu_kamdi,
                firstname: "Himanshu",
                lastname: "Kamdi",
                html: himanshu_kamdi_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: arsh_maknojia,
                firstname: "Arsh",
                lastname: "Maknojia",
                html: arsh_maknojia_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: sarvesh_mankar,
                firstname: "Sarvesh",
                lastname: "Mankar",
                html: sarvesh_mankar_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: soham_kumthekar,
                firstname: "Soham",
                lastname: "Kumthekar",
                html: soham_kumthekar_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: sanika_kulkarni,
                firstname: "Sanika",
                lastname: "Kulkarni",
                html: sanika_kulkarni_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: sakshi_mahajan,
                firstname: "Sakshi",
                lastname: "Mahajan",
                html: sakshi_mahajan_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: shriya_kale,
                firstname: "Shriya",
                lastname: "Kale",
                html: shriya_kale_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: bhagyashree_lomesh_patil,
                firstname: "Bhagyashree Lomesh",
                lastname: "Patil",
                html: bhagyashree_lomesh_patil_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: anushka_more,
                firstname: "Anushka",
                lastname: "More",
                html: anushka_more_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: utkarsha_gore,
                firstname: "Utkarsha",
                lastname: "Gore",
                html: utkarsha_gore_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: rujuta_budke,
                firstname: "Rujuta",
                lastname: "Budke",
                html: rujuta_budke_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: advait_karmalkar,
                firstname: "Advait",
                lastname: "Karmalkar",
                html: advait_karmalkar_html,
                isNew: false,
                date: {
                    day: "8",
                    super: "th",
                    rest: "May, 2023"
                },
                batch: "2024"
            },
            {
                image: siddhi_shinde,
                firstname: "Siddhi",
                lastname: "Shinde",
                html: siddhi_shinde_html,
                isNew: false,
                date: {
                    day: "8",
                    super: "th",
                    rest: "May, 2023"
                },
                batch: "2024"
            },
            {
                image: sneha_venk,
                firstname: "Sneha",
                lastname: "Venkateswaran",
                html: sneha_venk_html,
                isNew: false,
                date: {
                    day: "8",
                    super: "th",
                    rest: "May, 2023"
                },
                batch: "2024"
            },
            {
                image: anushka_naik,
                firstname: "Anushka",
                lastname: "Naik",
                html: anushka_naik_html,
                isNew: false,
                date: {
                    day: "8",
                    super: "th",
                    rest: "May, 2023"
                },
                batch: "2024"
            },
            {
                image: dhanashree_mahadeo,
                firstname: "Dhanashree",
                lastname: "Pawar",
                html: dhanashree_mahadeo_html,
                isNew: false,
                date: {
                    day: "8",
                    super: "th",
                    rest: "May, 2023"
                },
                batch: "2024"
            },
            {
                image: shreya_vaidya,
                firstname: "Shreya",
                lastname: "Vaidya",
                html: shreya_vaidya_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: ketaki_jadhav,
                firstname: "Ketaki",
                lastname: "Jadhav",
                html: ketaki_jadhav_html,
                isNew: false,
                date: {
                    day: "7",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: atharva_marathe,
                firstname: "Atharva",
                lastname: "Marathe",
                html: atharva_marathe_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2023"
            },
            {
                image: viren,
                firstname: "Viren",
                lastname: "Patil",
                html: viren_html,
                isNew: false,
                date: {
                    day: "28",
                    super: "th",
                    rest: "June, 2021"
                },
                batch: "2022"
            },
            {
                image: hrishikesh,
                firstname: "Hrishikesh",
                lastname: "Athalye",
                html: hrishikesh_html,
                isNew: false,
                date: {
                    day: "30",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: swebert,
                firstname: "Swebert",
                lastname: "Correa",
                html: swebert_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: akansha_patil_2027,
                firstname: "Akansha",
                lastname: "Patil",
                html: akansha_patil_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: aniket_ware_2027,
                firstname: "Aniket",
                lastname: "Ware",
                html: aniket_ware_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: apurva_palwe_2027,
                firstname: "Apurva",
                lastname: "Palwe",
                html: apurva_palwe_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: bhagyashree_patil_2027,
                firstname: "Bhagyashree",
                lastname: "Patil",
                html: bhagyashree_patil_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: arya_kulkarnia8_2027,
                firstname: "Arya",
                lastname: "Kulkarni",
                html: arya_kulkarnia8_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "Deutsche Bank",
        logo: DeutscheLogo,
        isUpdated: true,
        batches: [
            "2023",
            "2024",
            "2025",
            "2026",
            "2027"
        ],
        interns: [
            {
                image: chirag_ingale,
                firstname: "Chirag",
                lastname: "Ingale",
                html: chirag_ingale_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: soham_laghate,
                firstname: "Soham",
                lastname: "Laghate",
                html: soham_laghate_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: tanuja_patil,
                firstname: "Tanuja",
                lastname: "Patil",
                html: tanuja_patil_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: isha_khutafale,
                firstname: "Isha",
                lastname: "Khutafale",
                html: isha_khutafale_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: ishita_gaikwad,
                firstname: "Ishita",
                lastname: "Gaikwad",
                html: ishita_gaikwad_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: sayali_khedkar,
                firstname: "Sayali",
                lastname: "Khedkar",
                html: sayali_khedkar_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: vaishnavi_badgujar,
                firstname: "Vaishnavi",
                lastname: "Badgujar",
                html: vaishnavi_badgujar_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: ketan_kale,
                firstname: "Ketan",
                lastname: "Kale",
                html: ketan_kale_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: samruddhi_kamthe,
                firstname: "Samruddhi",
                lastname: "Kamthe",
                html: samruddhi_kamthe_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: ritesh_chaudhari,
                firstname: "Ritesh",
                lastname: "Chaudhari",
                html: ritesh_chaudhari_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: harshal_kausadikar,
                firstname: "Harshal",
                lastname: "Kausadikar",
                html: harshal_kausadikar_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: om_khare,
                firstname: "Om",
                lastname: "Khare",
                html: om_khare_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: prerna_tulsiani,
                firstname: "Prerna",
                lastname: "Tulsiani",
                html: prerna_tulsiani_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: aman_patil,
                firstname: "Aman",
                lastname: "Patil",
                html: aman_patil_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: apurva_deshpande,
                firstname: "Apurva",
                lastname: "Deshpande",
                html: apurva_deshpande_html,
                isNew: false,
                date: {
                    day: "7",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: anjali_dofe,
                firstname: "Anjali",
                lastname: "Dofe",
                html: anjali_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2023"
            },
            {
                image: aastha_jajoo_2027,
                firstname: "Aastha",
                lastname: "Jajoo",
                html: aastha_jajoo_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: gauri_kale_2027,
                firstname: "Gauri",
                lastname: "Kale",
                html: gauri_kale_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: krushna_bankar_2027,
                firstname: "Krushna",
                lastname: "Bankar",
                html: krushna_bankar_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: sahil_malawde_2027,
                firstname: "Sahil",
                lastname: "Malawde",
                html: sahil_malawde_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: siddhi_landage_2027,
                firstname: "Siddhi",
                lastname: "Landage",
                html: siddhi_landage_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: vaishnavi_shambharkar_2027,
                firstname: "Vaishnavi",
                lastname: "Shambharkar",
                html: vaishnavi_shambharkar_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: riya_kulkarni_2027,
                firstname: "Riya",
                lastname: "Kulkarni",
                html: riya_kulkarni_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "Hilti Technology",
        logo: HiltiLogo,
        isUpdated: true,
        batches: [
            "2024",
            "2025",
            "2026",
            "2027"
        ],
        interns: [
            {
                image: arya_wankhede,
                firstname: "Arya",
                lastname: "Wankhede",
                html: arya_wankhede_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2026"
            },
            {
                image: yash_hodlur,
                firstname: "Yash",
                lastname: "Hodlur",
                html: yash_hodlur_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2026"
            },
            {
                image: dhruv_sadhale,
                firstname: "Dhruv",
                lastname: "Sadhale",
                html: dhruv_sadhale_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2026"
            },
            {
                image: aveena_dange,
                firstname: "Aveena",
                lastname: "Dange",
                html: aveena_dange_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2026"
            },
            {
                image: soham_gupte,
                firstname: "Soham",
                lastname: "Gupte",
                html: soham_gupte_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2025"
            },
            {
                image: anvay_joshi,
                firstname: "Anvay",
                lastname: "Joshi",
                html: anvay_joshi_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: anagha_mahure,
                firstname: "Anagha",
                lastname: "Mahure",
                html: anagha_mahure_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: kaustubh_virkar,
                firstname: "Kaustubh",
                lastname: "Virkar",
                html: kaustubh_virkar_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: quasim_shaikh,
                firstname: "Qasim",
                lastname: "Shaikh",
                html: quasim_shaikh_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2024"
            },
            {
                image: nidhi_patel,
                firstname: "Nidhi",
                lastname: "Patel",
                html: nidhi_patel_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2024"
            },
            {
                image: anvita_mahajan,
                firstname: "Anvita",
                lastname: "Mahajan",
                html: anvita_mahajan_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2024"
            },
            {
                image: mehmood_deshmukh_2027,
                firstname: "Mehmood",
                lastname: "Deshmukh",
                html: mehmood_deshmukh_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: aryan_mehta_2027,
                firstname: "Aryan",
                lastname: "Mehta",
                html: aryan_mehta_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: rajvee_shah_2027,
                firstname: "Rajvee",
                lastname: "Shah",
                html: rajvee_shah_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: minautee_dighe_2027,
                firstname: "Minautee",
                lastname: "Dighe",
                html: minautee_dighe_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "DE Shaw",
        logo: DEShawLogo,
        isUpdated: true,
        batches: [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025",
            "2026",
            "2027"
        ],
        interns: [
            {
                image: arjun_deodhar,
                firstname: "Arjun",
                lastname: "Deodhar",
                html: arjun_deodhar_html,
                isNew: false,
                date: {
                    day: "21",
                    super: "st",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: jia_johnson,
                firstname: "Jia",
                lastname: "Johnson",
                html: jia_johnson_html,
                isNew: false,
                date: {
                    day: "21",
                    super: "st",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: atharva_mutsaddi,
                firstname: "Atharva",
                lastname: "Mutsaddi",
                html: atharva_mutsaddi_html,
                isNew: false,
                date: {
                    day: "21",
                    super: "st",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: vedanshi_shah,
                firstname: "Vedanshi",
                lastname: "Shah",
                html: vedanshi_shah_html,
                isNew: false,
                date: {
                    day: "7",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: sameer_kavthekar,
                firstname: "Sameer",
                lastname: "Kavthekar",
                html: sameer_kavthekar_html,
                isNew: false,
                date: {
                    day: "7",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: pallavi_buwa,
                firstname: "Pallavi",
                lastname: "Buwa",
                html: pallavi_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2023"
            },
            {
                image: anup,
                firstname: "Anup",
                lastname: "Nair",
                html: anup_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: soham,
                firstname: "Soham",
                lastname: "Parekh",
                html: soham_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: mayank,
                firstname: "Mayank",
                lastname: "Jain",
                html: mayank_html,
                isNew: false,
                date: {
                    day: "1",
                    super: "st",
                    rest: "July, 2020"
                },
                batch: "2021"
            },
            {
                image: aman_morghade_2027,
                firstname: "Aman",
                lastname: "Morghade",
                html: aman_morghade_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: sofiya_rukadikar_2027,
                firstname: "Sofiya",
                lastname: "Rukadikar",
                html: sofiya_rukadikar_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "ARCESIUM INDIA",
        logo: ArcesiumLogo,
        isUpdated: false,
        batches: [
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025",
            "2026"
        ],
        interns: [
            {
                image: pratham_tandale,
                firstname: "Pratham",
                lastname: "Tandale",
                html: pratham_tandale_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: payal_sankpal,
                firstname: "Payal",
                lastname: "Sankpal",
                html: payal_sankpal_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: pratyay_dhond,
                firstname: "Pratyay",
                lastname: "Dhond",
                html: pratyay_dhond_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: ayush_ambhorkar,
                firstname: "Ayush",
                lastname: "Ambhorkar",
                html: ayush_ambhorkar_html,
                isNew: false,
                date: {
                    day: "21",
                    super: "st",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: yash_suryawanshi,
                firstname: "Yash",
                lastname: "Suryawanshi",
                html: yash_suryawanshi_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2024"
            },
            {
                image: darshan_shah,
                firstname: "Darshan",
                lastname: "Shah",
                html: darshan_shah_html,
                isNew: false,
                date: {
                    day: "7",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: kartik_mandhan,
                firstname: "Kartik",
                lastname: "Mandhan",
                html: kartik_mandhan_html,
                isNew: false,
                date: {
                    day: "29",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2023"
            },
            {
                image: rohit,
                firstname: "Rohit",
                lastname: "Chaudhari",
                html: rohit_html,
                isNew: false,
                date: {
                    day: "9",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: mugdha,
                firstname: "Mugdha",
                lastname: "Bapat",
                html: mugdha_html,
                isNew: false,
                date: {
                    day: "9",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: ankita,
                firstname: "Ankita",
                lastname: "Vaid",
                html: ankita_html,
                isNew: false,
                date: {
                    day: "1",
                    super: "st",
                    rest: "July, 2020"
                },
                batch: "2021"
            },
            {
                image: savan,
                firstname: "Savan",
                lastname: "Nahar",
                html: savan_nahar_html,
                isNew: false,
                date: {
                    day: "21",
                    super: "st",
                    rest: "May, 2020"
                },
                batch: "2020"
            }
        ]
    },
    {
        company: "Wells Fargo",
        logo: WellsFargo,
        isUpdated: true,
        batches: [
            "2023",
            "2024",
            "2025",
            "2026",
            "2027"
        ],
        interns: [
            {
                image: aashay_inamdar,
                firstname: "Aashay",
                lastname: "Inamdar",
                html: aashay_inamdar_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: amruni_mehta,
                firstname: "Amruni",
                lastname: "Mehta",
                html: amruni_mehta_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: anshul_shelokar,
                firstname: "Anshul",
                lastname: "Shelokar",
                html: anshul_shelokar_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: arnav_gavde,
                firstname: "Arnav",
                lastname: "Gavde",
                html: arnav_gavde_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: lizna_charaniya,
                firstname: "Lizna",
                lastname: "Charaniya",
                html: lizna_charaniya_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: piyush_deshpande,
                firstname: "Piyush",
                lastname: "Deshpande",
                html: piyush_deshpande_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: shraddha_darade,
                firstname: "Shraddha",
                lastname: "Darade",
                html: shraddha_darade_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: saanvi_shet,
                firstname: "Saanvi",
                lastname: "Shet",
                html: saanvi_shet_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: suyog_arlimar,
                firstname: "Suyog",
                lastname: "Arlimar",
                html: suyog_arlimar_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: atharva_satav,
                firstname: "Atharva",
                lastname: "Satav",
                html: atharva_satav_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: vadiraj_joshi,
                firstname: "Vadiraj",
                lastname: "Joshi",
                html: vadiraj_joshi_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: simran_veer,
                firstname: "Simran",
                lastname: "Veer",
                html: simran_veer_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: preet_trivedi,
                firstname: "Preet",
                lastname: "Trivedi",
                html: preet_trivedi_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: omkar_oak,
                firstname: "Omkar",
                lastname: "Oak",
                html: omkar_oak_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: omkar_nagwekar,
                firstname: "Omkar",
                lastname: "Nagwekar",
                html: omkar_nagwekar_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: harshwardhan_deshmukh,
                firstname: "Harshwardhan",
                lastname: "Deshmukh",
                html: harshwardhan_deshmukh_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: aditya_raskar,
                firstname: "Aditya",
                lastname: "Raskar",
                html: aditya_raskar_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: anuksha_koul,
                firstname: "Anuksha",
                lastname: "Koul",
                html: anuksha_koul_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: abhinav_kurule,
                firstname: "Abhinav",
                lastname: "Kurule",
                html: abhinav_kurule_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: ninad_barve,
                firstname: "Ninad",
                lastname: "Barve",
                html: ninad_barve_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2024"
            },
            {
                image: aditya_naik,
                firstname: "Aditya",
                lastname: "Naik",
                html: aditya_naik_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2024"
            },
            {
                image: atharva_muglikar,
                firstname: "Atharva",
                lastname: "Muglikar",
                html: atharva_muglikar_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2024"
            },
            {
                image: ritik,
                firstname: "Ritik",
                lastname: "Naik",
                html: ritik_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2023"
            },
            {
                image: arya_kulkarni_2027,
                firstname: "Arya",
                lastname: "Kulkarni",
                html: arya_kulkarni_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: hakimuddin_slatewala_2027,
                firstname: "Hakimuddin",
                lastname: "Slatewala",
                html: hakimuddin_slatewala_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: shantanu_benake_2027,
                firstname: "Shantanu",
                lastname: "Benake",
                html: shantanu_benake_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: sarthika_kashmire_2027,
                firstname: "Sarthika",
                lastname: "Kashmire",
                html: sarthika_kashmire_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: shweta_jadhav_2027,
                firstname: "Shweta",
                lastname: "Jadhav",
                html: shweta_jadhav_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: suraj_sonawane_2027,
                firstname: "Suraj",
                lastname: "Sonawane",
                html: suraj_sonawane_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: swapna_khare_2027,
                firstname: "Swapna",
                lastname: "Khare",
                html: swapna_khare_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "Pattern Technologies",
        logo: PatternLogo,
        isUpdated: true,
        batches: [
            "2025",
            "2026",
            "2027"
        ],
        interns: [
            {
                image: prajwal_bhosale,
                firstname: "Prajwal",
                lastname: "Bhosale",
                html: prajwal_bhosale_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: deep_oak,
                firstname: "Deep",
                lastname: "Oak",
                html: deep_oak_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: vaishnavi_shelar,
                firstname: "Vaishnavi",
                lastname: "Shelar",
                html: vaishnavi_shelar_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: jay_kolhe,
                firstname: "Jay",
                lastname: "Kolhe",
                html: jay_kolhe_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: avdhut_kamble,
                firstname: "Avdhut",
                lastname: "Kamble",
                html: avdhut_kamble_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: parth_yewale,
                firstname: "Parth",
                lastname: "Yewale",
                html: parth_yewale_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: renuka_padalkar,
                firstname: "Renuka",
                lastname: "Padalkar",
                html: renuka_padalkar_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: sandesh_sahane,
                firstname: "Sandesh",
                lastname: "Sahane",
                html: sandesh_sahane_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: soham_dombale,
                firstname: "Soham",
                lastname: "Dombale",
                html: soham_dombale_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: sohel_bargir,
                firstname: "Sohel",
                lastname: "Bargir",
                html: sohel_bargir_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: ankita_karhade_2027,
                firstname: "Ankita",
                lastname: "Karhade",
                html: ankita_karhade_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: disha_kadam_2027,
                firstname: "Disha",
                lastname: "Kadam",
                html: disha_kadam_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: mruganksha_kudake_2027,
                firstname: "Mruganksha",
                lastname: "Kudake",
                html: mruganksha_kudake_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: nishant_agte_2027,
                firstname: "Nishant",
                lastname: "Agte",
                html: nishant_agte_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: sayalee_khedekar_2027,
                firstname: "Sayalee",
                lastname: "Khedekar",
                html: sayalee_khedekar_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: shubhra_shevkar_2027,
                firstname: "Shubhra",
                lastname: "Shevkar",
                html: shubhra_shevkar_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "UBS",
        logo: UBSlogo,
        isUpdated: true,
        batches: [
            "2026",
            "2027"
        ],
        interns: [
            {
                image: arnav_prasad,
                firstname: "Arnav",
                lastname: "Prasad",
                html: arnav_prasad_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: smruti_pachpute,
                firstname: "Smruti",
                lastname: "Pachpute",
                html: smruti_pachpute_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: sarthak_pawar,
                firstname: "Sarthak",
                lastname: "Pawar",
                html: sarthak_pawar_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: shreyas_katkar,
                firstname: "Shreyas",
                lastname: "Katkar",
                html: shreyas_katkar_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: hardik_mutha_2027,
                firstname: "Hardik",
                lastname: "Mutha",
                html: hardik_mutha_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: yashwant_bhosale_2027,
                firstname: "Yashwant",
                lastname: "Bhosale",
                html: yashwant_bhosale_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "Mastercard",
        logo: MastercardLogo,
        isUpdated: true,
        batches: [
            "2021",
            "2022",
            "2025",
            "2026",
            "2027"
        ],
        interns: [
            {
                image: idris_adeeb,
                firstname: "Idris",
                lastname: "Adeeb",
                html: idris_adeeb_html,
                isNew: false,
                date: {
                    day: "24",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: mansi_kumar,
                firstname: "Mansi",
                lastname: "Kumar",
                html: mansi_kumar_html,
                isNew: false,
                date: {
                    day: "24",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: apurva_haspe,
                firstname: "Apurva",
                lastname: "Haspe",
                html: apurva_haspe_html,
                isNew: false,
                date: {
                    day: "24",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: shreya_bhatkhande,
                firstname: "Shreya",
                lastname: "Bhatkhande",
                html: shreya_bhatkhande_html,
                isNew: false,
                date: {
                    day: "24",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: snehasish_bose,
                firstname: "Snehasish",
                lastname: "Bose",
                html: snehasish_bose_html,
                isNew: false,
                date: {
                    day: "24",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: onkar_wagh,
                firstname: "Onkar",
                lastname: "Wagh",
                html: onkar_wagh_html,
                isNew: false,
                date: {
                    day: "24",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: parth_mane,
                firstname: "Parth",
                lastname: "Mane",
                html: parth_mane_html,
                isNew: false,
                date: {
                    day: "24",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: shruti_ravichandran,
                firstname: "Shruti",
                lastname: "Ravichandran",
                html: shruti_ravichandran_html,
                isNew: false,
                date: {
                    day: "24",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: sharvari_phand,
                firstname: "Sharvari",
                lastname: "Phand",
                html: sharvari_phand_html,
                isNew: false,
                date: {
                    day: "24",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: samarth_kanwate,
                firstname: "Samarth",
                lastname: "Kanwate",
                html: samarth_kanwate_html,
                isNew: false,
                date: {
                    day: "24",
                    super: "th",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: vasvi,
                firstname: "Vasvi",
                lastname: "Gupta",
                html: vasvi_html,
                isNew: false,
                date: {
                    day: "28",
                    super: "th",
                    rest: "June, 2021"
                },
                batch: "2022"
            },
            {
                image: chetas,
                firstname: "Chetas",
                lastname: "Borse",
                html: chetas_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: omkar,
                firstname: "Omkar",
                lastname: "Thorat",
                html: omkar_html,
                isNew: false,
                date: {
                    day: "26",
                    super: "th",
                    rest: "June, 2020"
                },
                batch: "2021"
            },
            {
                image: esha,
                firstname: "Eesha",
                lastname: "Kurode",
                html: eesha_html,
                isNew: false,
                date: {
                    day: "5",
                    super: "th",
                    rest: "May, 2020"
                },
                batch: "2021"
            },
            {
                image: anjali_phule_2027,
                firstname: "Anjali",
                lastname: "Phule",
                html: anjali_phule_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: sejal_pathak_2027,
                firstname: "Sejal",
                lastname: "Pathak",
                html: sejal_pathak_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: suswan_joglekar_2027,
                firstname: "Suswan",
                lastname: "Joglekar",
                html: suswan_joglekar_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: shripad_kulkarni_2027,
                firstname: "Shripad",
                lastname: "Kulkarni",
                html: shripad_kulkarni_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: viraj_nalbarwar_2027,
                firstname: "Viraj",
                lastname: "Nalbalwar",
                html: viraj_nalbarwar_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "Algoquant Fintech",
        logo: Algoquantlogo,
        isUpdated: false,
        batches: [
            "2025",
            "2026"
        ],
        interns: [
            {
                image: aditya_deshmukh,
                firstname: "Aditya",
                lastname: "Deshmukh",
                html: aditya_deshmukh_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: avadhoot_ghewade,
                firstname: "Avadhoot",
                lastname: "Ghewade",
                html: avadhoot_ghewade_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: gaurish_dodke,
                firstname: "Gaurish",
                lastname: "Dodke",
                html: gaurish_dodke_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            }
        ]
    },
    {
        company: "BP Global Services",
        logo: bplogo,
        isUpdated: true,
        batches: [
            "2025",
            "2026",
            "2027"
        ],
        interns: [
            {
                image: atharv_munot,
                firstname: "Atharv",
                lastname: "Munot",
                html: atharv_munot_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: srushti_gadale,
                firstname: "Srushti",
                lastname: "Gadale",
                html: srushti_gadale_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: shubham_gupta,
                firstname: "Shubham",
                lastname: "Gupta",
                html: shubham_gupta_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: moin_shaikh_2027,
                firstname: "Moin",
                lastname: "Shaikh",
                html: moin_shaikh_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: paras_anbhule_2027,
                firstname: "Paras",
                lastname: "Anbhule",
                html: paras_anbhule_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: tanishq_borkar_2027,
                firstname: "Tanishq",
                lastname: "Borkar",
                html: tanishq_borkar_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "Ideas SAS",
        logo: ideaslogo,
        isUpdated: true,
        batches: [
            "2026",
            "2027"
        ],
        interns: [
            {
                image: atharva_sardesai,
                firstname: "Atharva",
                lastname: "Sardesai",
                html: atharva_sardesai_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: soumyajit_das,
                firstname: "Soumyajit",
                lastname: "Das",
                html: soumyajit_das_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: aneesh_phatak_2027,
                firstname: "Aneesh",
                lastname: "Phatak",
                html: aneesh_phatak_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: noopur_karkare_2027,
                firstname: "Noopur",
                lastname: "Karkare",
                html: noopur_karkare_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: sreya_sudheeran_2027,
                firstname: "Sreya",
                lastname: "Sudheeran",
                html: sreya_sudheeran_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "NPCI",
        logo: npcilogo,
        isUpdated: false,
        batches: [
            "2026"
        ],
        interns: [
            {
                image: omkar_kale,
                firstname: "Omkar",
                lastname: "Kale",
                html: omkar_kale_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: chinmay_barve,
                firstname: "Chinmay",
                lastname: "Barve",
                html: chinmay_barve_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: paras_dhole,
                firstname: "Paras",
                lastname: "Dhole",
                html: paras_dhole_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: sakshi_powar,
                firstname: "Sakshi",
                lastname: "Powar",
                html: sakshi_powar_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            }
        ]
    },
    {
        company: "Marvell",
        logo: MarvellLogo,
        isUpdated: false,
        batches: [
            "2025",
            "2026"
        ],
        interns: [
            {
                image: aalokkumar,
                firstname: "Aalokkumar",
                lastname: "Jaiswal",
                html: aalokkumar_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: bhargav_gejji,
                firstname: "Bhargav",
                lastname: "Gejji",
                html: bhargav_gejji_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: onkar_bhagwat,
                firstname: "Onkar",
                lastname: "Bhagwat",
                html: onkar_bhagwat_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: riti_panganti,
                firstname: "Riti",
                lastname: "Panganti",
                html: riti_panganti_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2026"
            },
            {
                image: harsh_marke,
                firstname: "Harsh",
                lastname: "Marke",
                html: harsh_marke_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            }
        ]
    },
    {
        company: "Trading Technologies",
        logo: TradingLogo,
        isUpdated: true,
        batches: [
            "2025",
            "2027"
        ],
        interns: [
            {
                image: soham_naigaonkar,
                firstname: "Soham",
                lastname: "Naigaonkar",
                html: soham_naigaonkar_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: nikhil_kokale,
                firstname: "Nikhil",
                lastname: "Kokale",
                html: nikhil_kokale_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: keertivarma_2027,
                firstname: "Keertivarma",
                lastname: "",
                html: keertivarma_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: sagar_satbhai_2027,
                firstname: "Sagar",
                lastname: "Satbhai",
                html: sagar_satbhai_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: varun_kudtarkar_2027,
                firstname: "Varun",
                lastname: "Kudtarkar",
                html: varun_kudtarkar_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "BNY Mellon",
        logo: BNYLogo,
        isUpdated: false,
        batches: [
            "2024"
        ],
        interns: [
            {
                image: sayali_mate,
                firstname: "Sayali",
                lastname: "Mate",
                html: sayali_mate_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: saurabh_jog,
                firstname: "Saurabh",
                lastname: "Jog",
                html: saurabh_jog_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: rohit_magar,
                firstname: "Rohit",
                lastname: "Magar",
                html: rohit_magar_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: mayur_k,
                firstname: "Mayur",
                lastname: "Kongutte",
                html: mayur_kongutte_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2024"
            },
            {
                image: sehajdeep_singh,
                firstname: "Sehajdeep",
                lastname: "Singh",
                html: sehajdeep_singh_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2024"
            },
            {
                image: rachana_gade,
                firstname: "Rachana",
                lastname: "Gade",
                html: rachana_gade_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2024"
            },
            {
                image: pratik_patil,
                firstname: "Pratik",
                lastname: "Patil",
                html: pratik_patil_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2024"
            }
        ]
    },
    {
        company: "JP Morgan",
        logo: JPMLogo,
        isUpdated: false,
        batches: [
            "2024"
        ],
        interns: [
            {
                image: harshmohan_kulkarni,
                firstname: "Harshmohan",
                lastname: "Kulkarni",
                html: harshmohan_kulkarni_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2024"
            },
            {
                image: shubham_gandhi,
                firstname: "Shubham",
                lastname: "Gandhi",
                html: shubham_gandhi_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2024"
            }
        ]
    },
    {
        company: "BARCLAYS",
        logo: BarclaysLogo,
        isUpdated: false,
        batches: [
            "2022",
            "2023",
            "2024"
        ],
        interns: [
            {
                image: chitra_sangle,
                firstname: "Chitra",
                lastname: "Sangle",
                html: chitra_sangle_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: shitij_agrawal,
                firstname: "Shitij",
                lastname: "Agrawal",
                html: shitij_agrawal_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: shyam_aradhye,
                firstname: "Shyam",
                lastname: "Aradhye",
                html: shyam_aradhye_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: yash_chandak,
                firstname: "Yash",
                lastname: "Chandak",
                html: yash_chandak_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: purav_desai,
                firstname: "Purav",
                lastname: "Desai",
                html: purav_desai_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: jayesh,
                firstname: "Jayesh",
                lastname: "Gadilohar",
                html: jayesh_html,
                isNew: false,
                date: {
                    day: "7",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: sayali_patil,
                firstname: "Sayali",
                lastname: "Patil",
                html: sayali_html,
                isNew: false,
                date: {
                    day: "29",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2023"
            },
            {
                image: muskan,
                firstname: "Muskan",
                lastname: "Paryani",
                html: muskan_html,
                isNew: false,
                date: {
                    day: "28",
                    super: "th",
                    rest: "June, 2021"
                },
                batch: "2022"
            },
            {
                image: gaurav,
                firstname: "Gaurav",
                lastname: "Wawdhane",
                html: gaurav_html,
                isNew: false,
                date: {
                    day: "30",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: rhugaved,
                firstname: "Rhugaved",
                lastname: "Narmade",
                html: rhugaved_html,
                isNew: false,
                date: {
                    day: "16",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            }
        ]
    },
    {
        company: "Goldman Sachs",
        logo: GoldmanSachsLogo,
        isUpdated: true,
        batches: [
            "2021",
            "2022",
            "2023",
            "2027"
        ],
        interns: [
            {
                image: siya_dhokane,
                firstname: "Siya",
                lastname: "Dhokane",
                html: siya_dhokane_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: avishkar_andhale,
                firstname: "Avishkar",
                lastname: "Andhale",
                html: avishkar_andhale_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: vishwajit_kadam,
                firstname: "Vishwajit",
                lastname: "Kadam",
                html: vishwajit_kadam_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: nikita_tipule,
                firstname: "Nikita",
                lastname: "Tipule",
                html: nikita_tipule_html,
                isNew: false,
                date: {
                    day: "7",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: archisha_shukla,
                firstname: "Archisha",
                lastname: "Shukla",
                html: archisha_html,
                isNew: false,
                date: {
                    day: "29",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2023"
            },
            {
                image: prajakta_ghatage,
                firstname: "Prajakta",
                lastname: "Ghatage",
                html: prajakta_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2023"
            },
            {
                image: vrinda,
                firstname: "Vrinda",
                lastname: "Ahuja",
                html: vrinda_html,
                isNew: false,
                date: {
                    day: "30",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: simran,
                firstname: "Simran",
                lastname: "Kucheria",
                html: simran_html,
                isNew: false,
                date: {
                    day: "30",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: deepika,
                firstname: "Deepika",
                lastname: "Goyal",
                html: deepika_html,
                isNew: false,
                date: {
                    day: "16",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: vasu,
                firstname: "Vasu",
                lastname: "Sharma",
                html: vasu_html,
                isNew: false,
                date: {
                    day: "16",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: jinit,
                firstname: "Jinit",
                lastname: "Sanghvi",
                html: jinit_html,
                isNew: false,
                date: {
                    day: "16",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: abhinav,
                firstname: "Abhinav",
                lastname: "Roy",
                html: abhinav_html,
                isNew: false,
                date: {
                    day: "1",
                    super: "st",
                    rest: "July, 2020"
                },
                batch: "2021"
            },
            {
                image: shreya,
                firstname: "Shreya",
                lastname: "Singhal",
                html: shreya_singhal_html,
                isNew: false,
                date: {
                    day: "26",
                    super: "th",
                    rest: "June, 2020"
                },
                batch: "2021"
            },
            {
                image: aneesh_topkar_2027,
                firstname: "Aneesh",
                lastname: "Topkar",
                html: aneesh_topkar_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: janhavi_jain_2027,
                firstname: "Janhavi",
                lastname: "Jain",
                html: janhavi_jain_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: soumya_pachpor_2027,
                firstname: "Soumya",
                lastname: "Pachpor",
                html: soumya_pachpor_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "INXISE DATALABS",
        logo: InxiseLogo,
        isUpdated: false,
        batches: [
            "2023"
        ],
        interns: [
            {
                image: ashutosh_pardeshi,
                firstname: "Ashutosh",
                lastname: "Pardeshi",
                html: ashutosh_pardeshi_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2023"
            }
        ]
    },
    {
        company: "CREDIT SUISSE",
        logo: CreditSuisseLogo,
        isUpdated: false,
        batches: [
            "2021",
            "2022",
            "2023"
        ],
        interns: [
            {
                image: harish,
                firstname: "Harish",
                lastname: "Choudhary",
                html: harish_html,
                isNew: false,
                date: {
                    day: "29",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2023"
            },
            {
                image: atharv,
                firstname: "Atharva",
                lastname: "Phand",
                html: atharv_html,
                isNew: false,
                date: {
                    day: "30",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: falguni,
                firstname: "Falguni",
                lastname: "Patil",
                html: falguni_html,
                isNew: false,
                date: {
                    day: "21",
                    super: "st",
                    rest: "May, 2020"
                },
                batch: "2021"
            },
            {
                image: aayush,
                firstname: "Aayush",
                lastname: "Shah",
                html: aayush_html,
                isNew: false,
                date: {
                    day: "5",
                    super: "th",
                    rest: "May, 2020"
                },
                batch: "2021"
            }
        ]
    },
    {
        company: "FINIQ",
        logo: FinIQLogo,
        isUpdated: false,
        batches: [
            "2021",
            "2022",
            "2023",
            "2024"
        ],
        interns: [
            {
                image: rohit_shidid,
                firstname: "Rohit",
                lastname: "Shidid",
                html: rohit_shidid_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: harsh_pande,
                firstname: "Harsh",
                lastname: "Pande",
                html: harsh_pande_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: vaishnavi_pabalkar,
                firstname: "Vaishnavi",
                lastname: "Pabalkar",
                html: vaishnavi_pabalkar_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: ishan_patwardhan,
                firstname: "Ishan",
                lastname: "Patwardhan",
                html: ishan_patwardhan_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: christy_biju,
                firstname: "Christy",
                lastname: "Biju",
                html: christy_biju_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: anish_deshpande,
                firstname: "Anish",
                lastname: "Deshpande",
                html: anish_deshpande_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: tanmay_patil,
                firstname: "Tanmay",
                lastname: "Patil",
                html: tanmay_patil_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: sakshi_pawar,
                firstname: "Sakshi",
                lastname: "Pawar",
                html: sakshi_pawar_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: mudit_bapna,
                firstname: "Mudit",
                lastname: "Bapna",
                html: mudit_bapna_html,
                isNew: false,
                date: {
                    day: "22",
                    super: "nd",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: sanmeet,
                firstname: "Sanmeet",
                lastname: "Wakchaure",
                html: sanmeet_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: anushka_tadphale,
                firstname: "Anushka",
                lastname: "Tadphale",
                html: anushka_tadphale_html,
                isNew: false,
                date: {
                    day: "29",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2023"
            },
            {
                image: nimit_jain,
                firstname: "Nimit",
                lastname: "Jain",
                html: nimit_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2023"
            },
            {
                image: arya,
                firstname: "Arya",
                lastname: "Gandhi",
                html: arya_html,
                isNew: false,
                date: {
                    day: "30",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: soumitra,
                firstname: "Soumitra",
                lastname: "Tonapi",
                html: soumitra_html,
                isNew: false,
                date: {
                    day: "16",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            },
            {
                image: yash_g,
                firstname: "Yash",
                lastname: "Gangwar",
                html: yash_gangwar_html,
                isNew: false,
                date: {
                    day: "26",
                    super: "th",
                    rest: "June, 2020"
                },
                batch: "2021"
            }
        ]
    },
    {
        company: "Google",
        logo: GoogleLogo,
        isUpdated: false,
        batches: [
            "2022"
        ],
        interns: [
            {
                image: aniket,
                firstname: "Aniket",
                lastname: "Jayateerth",
                html: aniket_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "April, 2021"
                },
                batch: "2022"
            }
        ]
    },
    {
        company: "Schlumberger",
        logo: SchlumbergerLogo,
        isUpdated: false,
        batches: [
            "2022",
            "2024"
        ],
        interns: [
            {
                image: mihika_sanghvi,
                firstname: "Mihika",
                lastname: "Sanghvi",
                html: mihika_sanghvi_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: mihika_dravid,
                firstname: "Mihika",
                lastname: "Dravid",
                html: mihika_dravid_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2024"
            },
            {
                image: viraj,
                firstname: "Viraj",
                lastname: "Jadhav",
                html: viraj_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "April, 2021"
                },
                batch: "2022"
            }
        ]
    },
    {
        company: "GARRETT MOTION",
        logo: GarrettMotionLogo,
        isUpdated: false,
        batches: [
            "2022"
        ],
        interns: [
            {
                image: harshal,
                firstname: "Harshal",
                lastname: "Patil",
                html: harshal_html,
                isNew: false,
                date: {
                    day: "9",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            }
        ]
    },
    {
        company: "NUANCE",
        logo: NuanceLogo,
        isUpdated: false,
        batches: [
            "2022",
            "2023"
        ],
        interns: [
            {
                image: kunal_chaudhari,
                firstname: "Kunal",
                lastname: "Chaudhari",
                html: kunal_chaudhari_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2023"
            },
            {
                image: riddhi,
                firstname: "Riddhi",
                lastname: "Tharewal",
                html: riddhi_html,
                isNew: false,
                date: {
                    day: "29",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2023"
            },
            {
                image: manas,
                firstname: "Manas",
                lastname: "Nighrunkar",
                html: manas_html,
                isNew: false,
                date: {
                    day: "9",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            }
        ]
    },
    {
        company: "EQ TECHNOLOGIES",
        logo: eQLogo,
        isUpdated: false,
        batches: [
            "2022"
        ],
        interns: [
            {
                image: chinmay,
                firstname: "Chinmay",
                lastname: "Dixit",
                html: chinmay_html,
                isNew: false,
                date: {
                    day: "9",
                    super: "th",
                    rest: "April, 2021"
                },
                batch: "2022"
            }
        ]
    },
    {
        company: "WOLTERS KLUWER",
        logo: WoltersKluwerLogo,
        isUpdated: false,
        batches: [
            "2020"
        ],
        interns: [
            {
                image: yash_shah,
                firstname: "Yash",
                lastname: "Shah",
                html: yash_shah_html,
                isNew: false,
                date: {
                    day: "26",
                    super: "th",
                    rest: "June, 2020"
                },
                batch: "2020"
            }
        ]
    },
    {
        company: "STANDARD CHARTERED BANK",
        logo: StandardCharteredLogo,
        isUpdated: false,
        batches: [
            "2021"
        ],
        interns: [
            {
                image: naman,
                firstname: "Naman",
                lastname: "Modi",
                html: naman_html,
                isNew: false,
                date: {
                    day: "1",
                    super: "st",
                    rest: "July, 2020"
                },
                batch: "2021"
            },
            {
                image: naishadh,
                firstname: "Naishadh",
                lastname: "Vora",
                html: naishadh_html,
                isNew: false,
                date: {
                    day: "21",
                    super: "st",
                    rest: "May, 2020"
                },
                batch: "2021"
            }
        ]
    },
    {
        company: "QUESTIONPRO",
        logo: QuestionProLogo,
        isUpdated: false,
        batches: [
            "2021"
        ],
        interns: [
            {
                image: umang,
                firstname: "Umang",
                lastname: "Sakhare",
                html: umang_sakhare_html,
                isNew: false,
                date: {
                    day: "5",
                    super: "th",
                    rest: "May, 2020"
                },
                batch: "2021"
            }
        ]
    },
    {
        company: "PERSISTENT SYSTEMS",
        logo: Persistent,
        isUpdated: false,
        batches: [
            "2023"
        ],
        interns: [
            {
                image: vishwesh,
                firstname: "Vishwesh",
                lastname: "Pujari",
                html: vishwesh_html,
                isNew: false,
                date: {
                    day: "18",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2023"
            }
        ]
    },
    {
        company: "TCS RESEARCH",
        logo: TcsLogo,
        isUpdated: false,
        batches: [
            "2023"
        ],
        interns: [
            {
                image: aditya,
                firstname: "Aditya",
                lastname: "Verma",
                html: aditya_html,
                isNew: false,
                date: {
                    day: "29",
                    super: "th",
                    rest: "May, 2022"
                },
                batch: "2023"
            }
        ]
    },
    {
        company: "Colgate Palmolive",
        logo: Colgate_palmolive,
        isUpdated: false,
        batches: [
            "2023"
        ],
        interns: [
            {
                image: tanmayee,
                firstname: "Tanmayee",
                lastname: "Bharati",
                html: tanmayee_html,
                isNew: false,
                date: {
                    day: "7",
                    super: "th",
                    rest: "June, 2022"
                },
                batch: "2023"
            }
        ]
    },
    {
        company: "CarrotSoft Technologies Pvt.Ltd.",
        logo: CarrotSoftlogo,
        isUpdated: false,
        batches: [
            "2024",
            "2025"
        ],
        interns: [
            {
                image: aditya_choudhary,
                firstname: "Aditya",
                lastname: "Choudhary",
                html: aditya_choudhary_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: chinmay_sheth,
                firstname: "Chinmay",
                lastname: "Sheth",
                html: chinmay_sheth_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: neha_pawar,
                firstname: "Neha",
                lastname: "Pawar",
                html: neha_pawar_html,
                isNew: false,
                date: {
                    day: "15",
                    super: "th",
                    rest: "June, 2023"
                },
                batch: "2024"
            }
        ]
    },
    {
        company: "HSBC Technology",
        logo: HSBCLogo,
        isUpdated: true,
        batches: [
            "2027"
        ],
        interns: [
            {
                image: sahil_tejwani_2027,
                firstname: "Sahil",
                lastname: "Tejwani",
                html: sahil_tejwani_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: siddhi_pawar_2027,
                firstname: "Siddhi",
                lastname: "Pawar",
                html: siddhi_pawar_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: yash_shah_2027,
                firstname: "Yash",
                lastname: "Shah",
                html: yash_shah_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: ansh_mehta_2027,
                firstname: "Ansh",
                lastname: "Mehta",
                html: ansh_mehta_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: saee_chavan_2027,
                firstname: "Saee",
                lastname: "Chavan",
                html: saee_chavan_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "Nvidia",
        logo: NvidiaLogo,
        isUpdated: true,
        batches: [
            "2027"
        ],
        interns: [
            {
                image: arshiya_kazi_2027,
                firstname: "Arshiya",
                lastname: "Kazi",
                html: arshiya_kazi_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: gayatri_potbhare_2027,
                firstname: "Gayatri",
                lastname: "Potbhare",
                html: gayatri_potbhare_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "Siemens Digital",
        logo: SiemensLogo,
        isUpdated: true,
        batches: [
            "2025",
            "2027"
        ],
        interns: [
            {
                image: aloki_upadhyay_2027,
                firstname: "Aloki",
                lastname: "Upadhyay",
                html: aloki_upadhyay_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: arnav_singhal_2027,
                firstname: "Arnav",
                lastname: "Singhal",
                html: arnav_singhal_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: davis_jojy_2027,
                firstname: "Davis",
                lastname: "Jojy",
                html: davis_jojy_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: ujwal_kitchloo_2027,
                firstname: "Ujwal",
                lastname: "Kitchloo",
                html: ujwal_kitchloo_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: vedang_khedekar,
                firstname: "Vedang",
                lastname: "Khedekar",
                html: vedang_khedekar_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: sanchit_rajmane,
                firstname: "Sanchit",
                lastname: "Rajmane",
                html: sanchit_rajmane_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: aman_sayyad,
                firstname: "Aman",
                lastname: "Sayyad",
                html: aman_sayyad_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: shreeya_ganji,
                firstname: "Shreeya",
                lastname: "Ganji",
                html: shreeya_ganji_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            },
            {
                image: vaishnavi_mulik,
                firstname: "Vaishnavi",
                lastname: "Mulik",
                html: vaishnavi_mulik_html,
                isNew: false,
                date: {
                    day: "23",
                    super: "rd",
                    rest: "July, 2024"
                },
                batch: "2025"
            }
        ]
    },
    {
        company: "Texas Instruments",
        logo: TexasLogo,
        isUpdated: true,
        batches: [
            "2027"
        ],
        interns: [
            {
                image: alhad_deodhar_2027,
                firstname: "Alhad",
                lastname: "Deodhar",
                html: alhad_deodhar_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            },
            {
                image: tanmay_karad_2027,
                firstname: "Tanmay",
                lastname: "Karad",
                html: tanmay_karad_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    },
    {
        company: "Accenture",
        logo: AccentureLogo,
        isUpdated: true,
        batches: [
            "2027"
        ],
        interns: [
            {
                image: shloka_shinde_2027,
                firstname: "Shloka",
                lastname: "Shinde",
                html: shloka_shinde_2027_html,
                isNew: true,
                date: {
                    day: "7",
                    super: "th",
                    rest: "October, 2025"
                },
                batch: "2027"
            }
        ]
    }
];

const newDiaries = data.filter((d) => d.isUpdated === true);
const oldDiaries = data.filter((d) => d.isUpdated === false);
data = [...newDiaries, ...oldDiaries];
